import type { Translations } from "../index";

export const zhCN: Translations = {
  lang: {
    en: "EN",
    ja: "日本語",
    "zh-HK": "繁中",
    "zh-TW": "繁中",
    "zh-CN": "简中",
    ko: "한국어",
    th: "ไทย",
    ru: "RU",
    current: "简体中文",
  },

  nav: {
    platform: "平台",
    forDesigners: "设计师专区",
    forBrands: "品牌专区",
    forManufacturers: "生产",
    forStudio: "Studio",
    caraAi: "Cara AI",
    pricing: "定价",
    more: "更多",
    about: "关于我们",
    academy: "学院",
    accessPlatform: "进入平台 →",
    subline: "设计遇见生产之地",
    sublineBrand: "采购 · 投产 · 上市",
    sublineDesigner: "珠宝设计师的舞台",
    inspire: "灵感",
    newsroom: "新闻中心",
    contact: "联系我们",
    catalog: "产品目录",
    showcase: "设计展示",
    switchToDesigners: "设计师专区 →",
    switchToBrands: "品牌专区 →",
    howItWorks: "运作方式",
    overview: "概览",
  },

  footer: {
    subline: "设计师珠宝 · B2B 采购 · EPH 制造",
    tagline: "「卓越设计与无瑕制造\n在此交汇。」",
    accessPlatform: "进入平台 →",
    ephCertified: "EPH 认证制造",
    copyright: "Caratzon Ltd. 版权所有。",
    columns: {
      platform: "平台",
      company: "公司",
      resources: "资源",
      contact: "联系",
    },
    links: {
      forDesigners: "设计师专区",
      forBrands: "品牌专区",
      forManufacturers: "生产",
      caraAi: "Cara AI",
      tradeCatalogue: "贸易目录",
      accessPlatform: "进入平台",
      aboutCaratzon: "关于 Caratzon",
      ourStory: "我们的故事",
      leadership: "管理团队",
      pressMedia: "媒体报道",
      investorRelations: "投资者关系",
      howItWorks: "平台运作方式",
      ephHub: "EPH 制造基地",
      sustainabilityReport: "可持续发展报告",
      cadStandards: "CAD 规格标准",
      supplierCode: "供应商行为准则",
      academy: "学院",
      inspire: "灵感",
      newsroom: "新闻中心",
      aiCredits: "AI 积分",
      contactUs: "联系我们",
      becomeManufacturer: "成为制造合作伙伴",
    },
    offices: {
      hongkong: "设计门户 · 香港",
      guangdong: "制造基地 · 广东",
      london: "欧洲贸易办事处",
    },
    legal: {
      terms: "服务条款",
      privacy: "隐私政策",
      cookies: "Cookie 政策",
      supplierCode: "供应商准则",
    },
  },

  home: {
    meta: {
      title: "Caratzon — B2B 珠宝采购 · 预工程 CAD · AI 营销",
      description:
        "顶级 B2B 独立精品珠宝采购平台。授权预工程 CAD 设计，在 EPH 进行可持续生产，通过 Caratzon Studio 即时生成营销素材。三级 IP 授权，端到端生产管理。",
    },
    emergence: {
      tagline: "从草稿到货架。设计、授权、生产——只需 Caratzon。",
      subtitle: "珠宝设计、授权与生产的 B2B 平台",
      cta: "浏览目录",
      ctaSecondary: "了解运作方式",
    },
    process: {
      overline: "运作方式",
      steps: [
        { number: "01", heading: "发现", body: "浏览来自全球独立设计师的预制原创作品。", hook: "无需研发成本。无需开模费用。" },
        { number: "02", heading: "授权", body: "选择您的知识产权层级，数秒内取得商业授权。", hook: "每份授权均附带营销素材。" },
        { number: "03", heading: "生产", body: "设计直接送入 EPH 的可持续制造中心。完成。", hook: "零工厂管理。全程可追溯。" },
      ],
    },
    storyBeat: {
      line1: "从草图到货架。",
      line2: "设计、授权、制造。",
      line3: "唯有 Caratzon。",
      splitLabel: "我是",
      splitDesigner: "设计师",
      splitBrand: "品牌买家",
    },
    showcase: {
      pieces: [
        {
          sku: "FD001-251225032",
          designer: "雅玉工作室",
          name: "天幕垂链",
          descriptor: "流金悬光，静待绽放。",
        },
        {
          sku: "FD016-251224017",
          designer: "金葫芦",
          name: "福禄葫芦吊坠",
          descriptor: "古韵符号，当代轮廓。",
        },
        {
          sku: "FD033-251225049",
          designer: "牡丹工坊",
          name: "花瓣垂耳环",
          descriptor: "花瓣半落，凝于瞬间。",
        },
        {
          sku: "FD051-251226013",
          designer: "玉河设计",
          name: "涟漪手镯",
          descriptor: "水波凝腕，流金定格。",
        },
      ],
    },
    stats: [
      { value: "48+", numericValue: 48, label: "原创设计" },
      { value: "12", numericValue: 12, label: "独立设计师" },
      { value: "6", numericValue: 6, label: "国家" },
      { value: "80%", numericValue: 80, label: "设计师收入分成", suffix: "%" },
    ],
    fork: {
      heading: "现在，你属于哪个世界？",
      designer: {
        eyebrow: "设计师专区",
        line: "你的工艺值得一个世界舞台——而不是又一条 Instagram 帖子。",
        cta: "以设计师身份进入",
      },
      brand: {
        eyebrow: "品牌专区",
        line: "跳过研发。授权附带营销素材。今天就上架。",
        cta: "以品牌身份进入",
      },
    },
    close: {
      line: "下一个篇章，由此开始。",
      cta: "立即开始",
    },
    hero: {
      overline: "B2B 采购平台 · 经 EPH 可持续生产",
      h1Line1: "采购设计。",
      h1Line2: "跳过研发。",
      h1Line3: "即刻上市。",
      tagline: "顶级 B2B 独立精品珠宝采购平台。授权预工程 CAD 设计，在 EPH 枢纽进行可持续生产，AI Studio 在您点击「购买」的瞬间自动生成营销素材。",
      cta: "浏览贸易目录",
      ctaSecondary: "了解 Caratzon Studio",
    },
    pillars: {
      overline: "平台能力",
      subtitle: "端到端工作流程",
      items: [
        {
          heading: "AI 营销引擎（Caratzon Studio）",
          body: "无需等待数周拍摄样品照片。每份授权均包含 Essentials Kit（电商产品图、规格及 SEO 文案）。升级至 Caratzon Kit 可自动生成生活方式摄影、社交媒体素材及以您品牌色彩定制的 PDF 批发单。",
        },
        {
          heading: "三级 IP 授权，法律文件保障",
          body: "标准（非独家）、季节性禁售（12 个月独家）或完整 Vault IP（永久 IP 转让）。具法律约束力的商业权利——不仅仅是握手协议。",
        },
        {
          heading: "端到端 EPH 生产",
          body: "您的订单直接路由至我们经验证的 EPH 制造网络。铸造、镶嵌、品质管控及物流均在一个统合的可持续枢纽中管理。无需工厂谈判。",
        },
      ],
    },
    quote: {
      text: "「下一季系列——无研发、无代理、无工厂需管。\n采购到上架，一平台搞定。」",
      attribution: "Caratzon 理念",
    },
    marquee: {
      ariaLabel: "目录预览",
    },
    howItWorks: {
      overline: "运作方式",
      subtitle: "三个步骤",
      items: [
        {
          heading: "发现",
          body: "浏览独立创作者的预工程原创设计。预览每件作品的 Essentials Kit——型录照片、规格、编辑故事及交互式 3D 浏览器——在承诺前评估完整套装。",
        },
        {
          heading: "授权与生成",
          body: "选择您的 IP 层级（标准、禁售或 Vault），数秒内取得商业权利。授权完成的瞬间，Caratzon Studio 即为您生成完整营销套件，让您的销售团队立即开始工作。",
        },
        {
          heading: "EPH 生产",
          body: "已批准的设计路由至 EPH 统合设施。可持续电镀、认证环保流程、端到端里程碑追踪——而您的营销素材已经上线。",
        },
      ],
    },
    eph: {
      overline: "制造伙伴",
      location: "中国",
      headline: "中国最大可持续一站式珠宝及环保电镀制造基地",
      body: "所有经 Caratzon 下达的生产订单均在 EPH 一站式工厂完成——铸造、镶嵌、抛光及环保电镀同一厂房进行，全面符合环保法规，生产进度逐步可追溯。",
      attrs: [
        {
          label: "环保电镀",
          body: "低排放环保电镀产线——黄金、铑及合金表面处理，经验证减少化学废物，采用闭环水循环系统。",
        },
        {
          label: "一站式制造设施",
          body: "铸造、镶嵌、抛光及电镀同一厂房完成。减少交接、提升精度、缩短生产周期。",
        },
        {
          label: "系统直接对接",
          body: "Caratzon 平台上获批的设计自动进入 EPH 生产排程，无需人工重新下单，供应链零断层。",
        },
        {
          label: "全程可追溯",
          body: "每个生产阶段均记录于您的 Caratzon 控制台——从原材料收货到最终品控签收，一目了然。",
        },
      ],
    },
    forWhom: {
      overline: "适用对象",
      heading: "专为\n贸易买家而建。",
      items: [
        {
          title: "珠宝零售商",
          desc: "采购竞争对手无法找到的设计师直送作品。每份授权均包含 Essentials Kit——型录照片、规格及 SEO 文案即时就绪。升级至 Caratzon Kit 获取生活方式摄影及社交素材。授权当天即可上架网站、加入型录并发布 Instagram。",
        },
        {
          title: "精品店主",
          desc: "跳过每件设计 $1,500 以上的 NRE（非经常性工程）成本。授权经测试的生产就绪原创设计。生成您的 Caratzon Kit，在签署授权的同一天将新品上架 Shopify。",
        },
        {
          title: "多品牌经销商",
          desc: "通过单一供应商档案从数十位全球独立设计师采购。自动生成格式完美的 PDF 批发单，即时分享给您的零售客户。",
        },
      ],
    },
    caraAI: {
      overline: "Cara AI · 工程智能",
      heading: "为工厂\n而设计的 AI。",
      body: "Cara 不会生成幻想渲染图。它工程化设计能够通过失蜡铸造、宝石镶嵌，并在手上佩戴一整天仍感舒适的珠宝——然后在您喝完咖啡之前生成完整的物料清单。",
      stats: [
        { value: "±0.15mm", label: "每种合金的收缩补偿" },
        { value: "0.6mm", label: "强制最小壁厚" },
        { value: "4-Prong+", label: "宝石固定工程设计" },
        { value: "R≥0.4mm", label: "全天舒适的边缘半径" },
      ],
      cta: "试用 Cara AI — 现场演示",
      ctaSecondary: "了解更多",
    },
    inspirePreview: {
      overline: "在 Inspire 上探索",
      heading: "浏览。收藏。采购。",
      body: "欢迎来到 Caratzon Inspire — 您的 B2B 灵感动态。浏览全球顶尖 3D CAD 设计的精选串流。建立您品牌的灵感板，关注您喜爱的独立创作者，一键从灵感转化为生产。",
      cta: "探索 Inspire",
    },
    designerBanner: {
      overline: "设计师专区",
      heading: "您的 CAD 文件值得\n更好的作品集。",
      body: "加入我们精选的全球 3D 创作者网络。上传您的预工程设计，自动解锁专属的 Caratzon Inspire 作品集。让我们的 AI 免费渲染您的文件，向数千名认证零售买家展示您的作品，并赚取高利润版税。",
      cta: "申请您的设计师作品集",
    },
    footerCta: {
      overline: "准备好采购了吗",
      heading: "下一季系列。\n一平台。零断层。",
      cta: "浏览贸易目录",
      tradeOnly: "仅限贸易账户",
    },
  },

  forDesigners: {
    meta: {
      title: "设计师专区 · Caratzon",
      description:
        "您的故事，由 AI 精心呈现。您的设计，面向全球买家。加入 Caratzon Inspire——上传 CAD、回答几个关于创作历程的问题，AI 即为您撰写设计师故事。每笔授权费赚取 80%，并享有持续版税。",
    },
    hero: {
      overline: "专为独立珠宝设计师而设",
      h1Line1: "您的故事。",
      h1Line2: "精彩呈现。",
      tagline:
        "回答几个关于您的工艺、灵感和愿景的问题。我们的 AI 将您的回答转化为引人入胜的设计师故事——并将您的作品呈现在全球买家面前。",
      cta: "成为灵感之源 →",
    },
    stats: {
      share: "您的授权费分成",
      ipProtected: "IP 受保护",
      cadNote: "CAD 绝不向买家披露",
      perpetual: "持续版税",
      royaltiesNote: "每件生产单品均可收取版税",
      zeroMarketing: "零营销负担",
      portfolioNote: "AI 为您构建故事",
    },
    badges: {
      premium: "高级",
    },
    pain: {
      overline: "现实",
      p1: "您是一位才华横溢的珠宝设计师。您的作品原创、精致，随时可以投产。",
      p2: "但为了维持生计，您不得不身兼社交媒体运营、文案撰写、生活方式摄影及工厂对接等多重角色。您最出色的作品压在硬盘里，因为您既没有时间、也没有资金将它们推广给全球 B2B 品牌。",
      quote: "我们创立 Caratzon，让全球最有才华的珠宝设计师可以专注于他们最擅长的事——设计。",
      quoteAttribution: "— Caratzon 创始团队",
    },
    inspire: {
      overline: "成为灵感之源",
      subtitle: "您的故事，由 AI 精心雕琢。",
      heading: "七个问题。\n一个难忘的故事。",
      p1: "在入驻过程中，我们会询问您的创作起源、设计理念、灵感来源以及作品背后的情感世界。这不是一份表格——而是一场关于您作为创作者身份的对话。",
      p2: "我们的 AI 将您的回答转化为杂志级别的设计师档案——标题、叙事、主题章节和品牌关键词。这种故事能让买家停下滚动，主动联系您。",
      features: [
        { label: "您的起源，您的声音", description: "我们会询问您如何成为设计师、哪些材料与您产生共鸣、以及哪些文化影响塑造了您的美学。您的话语成为公开故事的基础。" },
        { label: "理念与内心世界", description: "当有人佩戴您的珠宝时应该有什么感受？什么创作张力定义了您的作品？这些更深层的问题赋予 AI 心理质感，写出听起来像您而非模板的内容。" },
        { label: "发布在 Inspire", description: "您的 AI 生成故事将在 Inspire 创作者页面上线——一个买家、媒体和合作者可以发现的公开档案。随时从 Studio 仪表板编辑。" },
      ],
      previewLabel: "AI 生成预览",
      previewTitle: "张力 — Aria 的世界",
      previewBody: "她设计珠宝的方式如同建筑师思考光线——不是为了装饰，而是为了揭示。",
      previewExtended: "在俯瞰博斯普鲁斯海峡的阳光工作室里，Aria Atelier 在精准与狂野的交汇处创作。她的作品始于质感纸上的水彩草图——她需要先感受重量，才会触碰屏幕……",
      previewKeywords: ["张力", "黄金", "建筑感", "侘寂", "低调自信", "博斯普鲁斯之光"],
      cta: "成为灵感来源 →",
    },
    designOfWeek: {
      overline: "每周设计精选",
      subtitle: "全球推荐，每周甄选",
      heading: "入选\n每周设计精选。",
      badgeLabel: "本周设计",
      featuredTitle: "棱镜花瓣戒指",
      featuredAttribution: "by Aria Atelier · 2026年3月3日精选",
      p1: "每周，Caratzon 编辑团队会选出一件杰出设计在全平台聚焦展示。入选设计师将获得 Inspire 首页的显著位置、专属编辑特写，以及对整个买家网络的直接曝光。",
      p2: "每周设计精选不仅仅是曝光——它是向买家发出的信号，表明您的作品已获得业内最挑剔策展人的认可。过往入选者已获得授权交易、媒体报道和长期品牌合作。",
      benefits: [
        { label: "首页聚焦", description: "您的设计和故事将在 Inspire 首页显著展示七天——每位买家访问平台时看到的第一件作品。" },
        { label: "编辑特写", description: "基于您的 AI 生成故事撰写的专属编辑文章，扩展了设计灵感、材料和制造方法的背景。" },
        { label: "买家网络通知", description: "平台上每位活跃买家都会收到精选通知，展示您的设计。直接通往授权洽谈的渠道。" },
      ],
    },
    platform: {
      overline: "平台如何为您服务",
      subtitle: "零付出。最大触达。",
      items: [
        {
          heading: "AI 为您讲故事",
          body: "入驻时回答几个关于您工艺的问题。我们的 AI 撰写您的设计师故事、生成品牌关键词，并发布您的 Inspire 创作者页面——一份随您的作品持续更新的活档案。",
        },
        {
          heading: "直达全球买家",
          body: "您的自动化作品集将呈现在正在积极采购的大型零售品牌采购经理及买手面前。您无需主动推销——他们浏览我们的精选展示，自然发现您。",
        },
        {
          heading: "零生产烦恼",
          body: "品牌采购您的设计后，您无需与任何工厂沟通。我们的平台安全地将文件分配至精选制造伙伴。铸造、品控及物流全由我们处理。",
        },
        {
          heading: "滴水不漏的 IP 保护",
          body: "无论哪种授权模式，您的 CAD 文件绝不向买家披露。品牌仅获得生产权。您的源文件仅在 NDA 下提供给我们精选的制造伙伴。只有完整 IP 收购才会转让设计文件。",
        },
      ],
    },
    collections: {
      overline: "作品集 + AI 叙事",
      subtitle: "您的设计值得更多展现。",
      heading: "组合您的作品。\nAI 讲述故事。",
      p1: "选择两件或以上已发布的设计，我们的 AI 会发现连接它们的线索——共同材质、氛围、创意风格——并围绕这个核心构建完整的展示方案。",
      p2: "品牌看到的不只是零散的单品，而是一位拥有连贯创意理念和完整作品体系的设计师。这才是让他们主动联系您的关键。",
      features: [
        {
          label: "每件作品声调一致",
          description: "AI 识别贯穿您设计的创意主线——共同色调、氛围、灵感——让买家看到连贯的创意理念，而非杂乱的文件列表。",
        },
        {
          label: "您的作品讲述同一个故事",
          description: "一篇连贯的叙事，以名称引用每件设计，在作品之间建立关联。买家在咨询之前就能理解您作品集背后的理念。",
        },
        {
          label: "每个作品集都呈现杂志水准",
          description: "杂志级展示方案采用一致的编辑模板——封面视觉、作品聚焦，以及所有作品集统一的视觉风格。",
        },
      ],
      cta: "在 Studio 中探索作品集 →",
    },
    revenue: {
      overline: "您的收入，三种方式",
      subtitle: "三种获利方式",
      heading: "品牌有三种购买方式。\n您有三种获利途径。",
      footnote:
        "三种授权模式下，您均可保留 80% 的授权费。Caratzon 保留 20% 用于平台运营、营销及制造协调。标准授权和季节性独家授权将为您带来持续版税，每件生产单品均可获得收益——初始交易完成后，您的设计仍持续创造收益。完整独家授权是一次性、干净利落的 IP 买断：无持续版税，仅一次由您自主定价的高额付款。",
      models: [
        {
          tier: "标准",
          label: "非独家生产授权",
          heading: "标准授权",
          description:
            "品牌获得通过 Caratzon 制造网络生产您设计的权利。非独家——多个品牌可同时持有标准授权。您可从每笔授权费中赚取 80%，并从每件生产单品中持续获得版税。",
          benefit: "80% 归您 · 持续版税 · 设计保持市场流通",
        },
        {
          tier: "高级",
          label: "12 个月独家制造权",
          heading: "季节性独家授权",
          description:
            "品牌支付溢价，在 12 个月内独占您的设计。在其推广窗口期间，您的作品从市集隐藏——竞争对手无法生产。您可赚取 80% 的独家费用及每件生产单品的持续版税。窗口期结束后，设计重返公开市场。",
          benefit: "80% 归您 · 更高前期收益 · 有时限 · 可重复使用",
        },
        {
          tier: "金库",
          label: "完整独家版权",
          heading: "完整独家版权",
          description:
            "品牌获得永久所有权，直接获取原始生产文件（.STL / .3DM）。设计从市集永久下架。您可获得 80% 的一次性高额付款，金额由您自主设定。干净退出：一次付款，设计退场，无后续义务。",
          benefit: "80% 归您 · 您自主定价 · 一次性干净退出",
        },
      ],
    },
    steps: {
      overline: "从入驻到收入",
      subtitle: "三个步骤",
      items: [
        {
          heading: "成为灵感之源",
          body: "回答关于您的工艺、理念和灵感的问题。我们的 AI 生成您的设计师故事并发布到 Inspire 页面——买家发现您的公开创作者档案。上传您的首个 CAD 文件以完善作品集。",
        },
        {
          heading: "AI 构建您的品牌",
          body: "我们的 Story Lab 为每件作品生成影棚级 lookbook 摄影及编辑叙事。将设计组合成系列，AI 为所有作品撰写统一故事。入选每周设计精选可获最大曝光。",
        },
        {
          heading: "收取收入",
          body: "品牌发现您的作品并提出授权请求。您批准或反提条款。确认后，生产自动启动——铸造第一克金属之前，80% 授权费已到账，版税随每件生产单品持续流入。",
        },
      ],
    },
    bottomLine: {
      overline: "结语",
      p1: "您的工作是创作。我们的 AI 讲述您的故事。我们的平台销售您的作品。",
      p2: "从第一个入驻问题到第一笔授权交易——我们处理叙事、摄影、买家发现及制造。您只管设计。",
      shareLabel: "归您所有",
      shareNote:
        "每笔授权费的 80% 归您。标准授权和季节性独家授权每件生产单品均有持续版税。完整独家版权收购是一次性溢价，底价由您自定。Caratzon 的 20% 用于支持营销引擎——在您入睡后，它仍在为您的作品销售。",
    },
    cta: {
      overline: "成为灵感之源",
      heading: "您的故事。\n您的舞台。",
      primary: "成为灵感之源 →",
      secondary: "已是设计师？开启 Studio →",
    },
  },

  forBrands: {
    meta: {
      title: "品牌商专区 · Caratzon",
      description:
        "采购独立设计师的原创珠宝设计——每份授权均附带型录摄影、产品图片及编辑故事。标准授权、独家授权或完整版权。生产端到端全程管理。",
    },
    howItWorks: {
      meta: {
        title: "运作方式 — 品牌版 Caratzon",
        description: "从发现到交付——浏览设计师原创作品，选择授权层级，制造网络管理生产，营销素材即时上线。",
      },
      headline: "从发现\n到交付。",
      intro: "浏览认证设计师原创作品。选择授权方式。制造网络管理生产，营销素材即时上线。以下是详细流程。",
    },
    hero: {
      overline: "珠宝品牌 · 精品店 · 分销商",
      h1Line1: "下一季系列。",
      h1Line2: "无研发。无代理。",
      h1Line3: "无工厂需管。",
      tagline:
        "浏览独立创作者原创设计。授权所爱——型录图、规格及营销素材随每件作品交付。生产经 EPH 网络路由。采购到上架，一平台搞定。",
      ctaPrimary: "浏览贸易目录",
      ctaSecondary: "查看运作方式 →",
    },
    marquee: {
      ariaLabel: "目录预览",
    },
    badges: {
      fullIp: "完整 IP",
    },
    stats: {
      tiers: "采购模式",
      designerDirect: "设计师直供",
      noIntermediaries: "零中间商",
      contentReady: "内容齐备",
      contentReadySub: "Lookbook、产品图及故事已包含",
      productionManaged: "生产托管",
      endToEnd: "端到端",
    },
    acquire: {
      overline: "采购模式",
      subtitle: "您的系列，您的条款",
      heading: "三种方式采购\n一件 Caratzon 设计。",
      models: [
        {
          tier: "标准",
          label: "启动费及资产费",
          heading: "标准授权",
          description:
            "这不仅是一张许可证——它是物超所值的捷径。您购买的是一件已完成工程验证、压力测试并保证完美铸造的设计。您跳过了所有昂贵的试错步骤。非独家；其他品牌可同时持有授权。",
          gets: [
            "即时生产通道——设计即时解锁进入我们的生产管道",
            "零研发成本——预先工程化的 CAD，已验证可完美量产",
            "内容包已附带——型录摄影、产品图片及编辑故事，当天即可用于店铺",
            "商业使用权——以您自己的品牌白标销售，永久有效",
          ],
          benefit: "省去研发 · 内容已附带 · 当天上线",
        },
        {
          tier: "独家",
          label: "12 个月独家制造权",
          heading: "季节性独家授权",
          description:
            "为您的下一个推广活动锁定设计。独家制造权为期 12 个月——您的作品在市集隐藏，直至独家期到期。在您的窗口期内，竞争对手无法生产。独家期结束后，设计重返市场。",
          gets: [
            "独家锁定——窗口期内竞争对手零生产",
            "包含所有标准授权权益",
            "完整内容包已附带——独家型录摄影及编辑故事，12 个月内专属于您",
            "设计在完整独家期内从市集隐藏",
          ],
          benefit: "竞争对手防护窗口 · 独家内容 · 明星产品潜力",
        },
        {
          tier: "金库",
          label: "完整独家版权",
          heading: "完整独家版权",
          description:
            "永久持有 IP。获得永久所有权——设计立即从市集下架。付款后，您直接获得可量产的原始文件（.STL / .3DM）。任何其他品牌永远无法采购此设计。这是唯一涉及源文件转让的场景。",
          gets: [
            "永久 IP 所有权——设计从市集永久退场",
            "原始生产文件（.STL / .3DM）直接转让给您",
            "完整内容包 + Lookbook Studio——以 AI 生成无限量自定义摄影，配合您的品牌风格",
            "底价由设计师设定——在此基础上洽谈",
          ],
          benefit: "永久独家 · 完整内容套件 · CAD 在手",
        },
      ],
      whyStandard: {
        label: "为什么要支付标准授权费？",
        heading: "您不是在购买许可证，您是在购买一条捷径，其价值远不止费用本身。",
        points: [
          {
            heading: "省去研发费用",
            body: "在传统制造中，一件设计需要花费 $500–$2,000+ 用于 3D 设计费、蜡模打印、试铸及修改，才能投入量产。标准授权取代了所有这些——文件已完成工程化与压力测试。",
          },
          {
            heading: "当天即可在店铺上架",
            body: "授权包含影棚级型录摄影、产品图片及编辑故事——灯光、构图、风格均达编辑标准。无需摄影师，无需修图师。签约的那一刻，即可在您的店铺上架。",
          },
          {
            heading: "白标销售，无法律风险",
            body: "您获得在自己品牌名称和包装下销售的完整商业权利。设计师同意不追究版权问题。在他们的艺术基础上建立您的业务，零风险。",
          },
        ],
      },
      ipNotes: {
        standardLabel: "标准授权及季节性独家授权",
        standardBody:
          "生产文件由 Caratzon 保管，仅在保密协议下发布给我们精选的制造合作伙伴。您不会收到原始 CAD——生产通过我们的网络自动路由。",
        vaultLabel: "完整独家版权",
        vaultBody:
          "付款后，设计师的可量产 .STL / .3DM 文件直接转让给您。设计从目录中永久退场——任何其他品牌永远无法采购。",
      },
    },
    process: {
      overline: "平台运作方式",
      subtitle: "从探索到交付",
      items: [
        {
          heading: "探索",
          body: "浏览经过认证的设计师原创作品。每件作品均附带型录摄影、编辑故事及互动式 3D 查看器——在确认前可充分评估完整内容。",
        },
        {
          heading: "授权",
          body: "选择您的层级。提交采购请求，直接与设计师洽谈条款，锁定您的授权。所有过程均有文件记录，并以法律形式结构化。",
        },
        {
          heading: "生产",
          body: "您的订单路由至我们的制造网络——铸造、镶嵌、品控及物流端到端全程管理。生产进行的同时，您的型录摄影及故事已可上线。在库存到达前即可开始推广。",
        },
      ],
      quote: "「采购原创，规模化生产。\n无需自建工厂关系。」",
      bullets: [
        "横跨亚洲及欧洲的精选制造商网络",
        "铸造、镶嵌、品控及物流端到端全程管理",
        "每件设计均附带型录摄影、产品图片及编辑故事",
        "Lookbook Studio：按需生成自定义摄影，配合您的品牌风格",
      ],
      teaserItems: [
        { heading: "发现", body: "浏览认证设计师原创作品，支持完整预览。" },
        { heading: "授权", body: "选择层级，锁定商业权益。" },
        { heading: "投产", body: "资产上线的同时，制造端到端管理。" },
      ],
      teaserCta: "查看运作方式 →",
    },
    vs: {
      overline: "对比传统批发",
      traditional: "传统模式",
      caratzon: "Caratzon",
      rows: [
        ["来源可靠性", "来源不明，多层供应链", "直接来自经验证的独立设计师"],
        [
          "研发成本",
          "每件设计 $500–$2,000+（3D 设计费、蜡模打印、试铸、修改）",
          "零成本——预先工程化，已验证可完美量产",
        ],
        [
          "上市时间",
          "需数周工程设计及打样才能上架",
          "今日授权，今日上架——资产已附带",
        ],
        [
          "营销素材",
          "需自行聘请摄影师、造型师及文案——每个系列需耗费数周及数千成本",
          "型录摄影、产品图片及编辑故事已附带。数小时即可上市，而非数周",
        ],
        [
          "商业使用权",
          "需单独洽谈，往往不清晰",
          "包含白标使用权——永久以您自己的品牌销售",
        ],
        [
          "独家保护",
          "无机制阻止竞争对手",
          "标准授权、季节性独家授权（12 个月）或完整独家版权（永久）",
        ],
        [
          "生产管理",
          "自行维护工厂关系",
          "自动通过我们的制造网络路由",
        ],
      ],
    },
    studio: {
      overline: "Caratzon Studio",
      heading: "采购设计。\n我们生成营销素材。",
      intro:
        "采购新库存过去意味着等待数周才能拍摄样品照片。使用 Caratzon Studio，您的营销素材在获得授权的瞬间即自动生成。选择您的上市策略：",
      essentials: {
        heading: "Essentials Kit",
        badge: "每份授权均包含",
        body: "无需手动输入数据。授权设计的瞬间，即自动生成生产规格、清晰的型录照片和 SEO 文案。今天就将新库存上架到您的商店。",
        features: [
          "高分辨率白底电商产品图",
          "SEO 优化产品描述",
          "精确的技术与材质规格",
        ],
      },
      caratzonKit: {
        heading: "Caratzon Kit",
        badge: "高级上市升级",
        body: "无需拍摄。一键替代整个创意代理商。您的品牌标志、色彩和美学无缝融入生活方式照片、批发单和社交媒体素材。",
        features: [
          "AI 生成生活方式及模特摄影",
          "自动排版的品牌风格 PDF 批发单",
          "即时发布的社交媒体素材（Reels/TikTok 裁切及文案）",
        ],
      },
    },
    caraAI: {
      overline: "Cara AI · 工程智能",
      heading: "不是图像生成工具。\n是珠宝工程 AI。",
      intro: "大多数 AI 只会生成漂亮的图片。Cara 生成的设计能够经受工厂的考验，并且戴在手上感觉舒适。结果不是情绪板——而是附带完整物料清单的可投产蓝图。",
      pillars: [
        {
          stat: "±0.15mm",
          label: "收缩补偿",
          body: "Cara 在失蜡铸造过程中计入金属特定的收缩率——金、银、铂、黄铜——确保成品与数字模型一致，而非缩水的近似品。",
        },
        {
          stat: "0.6mm",
          label: "最小壁厚",
          body: "每个生成的造型都遵守合金特定的最小壁厚要求——铂金0.6mm，金和银0.8mm。没有薄如纸的爪镶，没有塌陷的包镶。设计在到达铸造师手中之前就已结构稳固。",
        },
        {
          stat: "4-Prong+",
          label: "宝石公差映射",
          body: "Cara 为每种宝石类型和切割方式计算爪位、座深和腰围间隙。镶嵌经过工程设计，确保日常佩戴下的稳固固定——而非仅仅视觉上的合理性。",
        },
        {
          stat: "R≥0.4mm",
          label: "佩戴感与手感",
          body: "Cara 评估戒圈轮廓、内弧度、重量分布和边缘半径，确保每件作品戴起来和看起来一样好。尖锐边缘、头重脚轻的平衡和夹点在设计离开屏幕之前就会被标记。",
        },
      ],
      capabilities: [
        { label: "铸造力学", detail: "浇口位置、闸口尺寸和流动分析，确保无缺陷铸造" },
        { label: "结构分析", detail: "经过应力测试的壁厚和整体形态负载分布检查" },
        { label: "物料清单", detail: "从概念阶段即提供准确的金属重量、宝石数量和成本估算" },
        { label: "合金智能", detail: "10K–24K 金、925 银、950 铂金和黄铜的材料特性" },
        { label: "生产就绪", detail: "每个输出都根据真实 EPH 制造公差进行评估" },
        { label: "草图到 CAD 桥接", detail: "上传餐巾纸草图——Cara 提取几何形状并为生产进行工程设计" },
      ],
      closing: "Cara 工程化的概念旨在一次铸造成功——无需返工、无浪费蜡模、无工厂退件。当买家看到 Cara 概念时，他们看到的是一件已经通过与制造商相同约束条件压力测试的作品。这就是生成式 AI 与工程 AI 的区别。",
      tryCara: "试用 Cara AI — 即时演示",
      learnMore: "了解更多",
    },
    cta: {
      overline: "开始采购",
      heading: "浏览\n贸易目录。",
      body: "每件设计均附带型录摄影、产品图片及编辑故事——授权即刻可发布。浏览、以 3D 评估，比任何传统流程更快上市。",
      primary: "浏览设计作品",
      secondary: "查看运作方式",
      tradeOnly: "仅限贸易账户",
    },
  },

  forManufacturers: {
    meta: {
      title: "生产制造 · Caratzon",
      description:
        "每一份 Caratzon 订单均在 EPH 生产——中国最大的一体化珠宝制造基地。5,000+ 制造商、环保认证电镀、从 CAD 到交付全程可追溯。",
    },
    hero: {
      overline: "生产制造 · EPH 制造基地",
      h1Line1: "一个基地。",
      h1Line2: "全链能力。",
      h1Line3: "5,000+ 制造商。",
      tagline:
        "每一份 Caratzon 订单均通过 EPH 路由——中国最大的一体化珠宝制造基地。5,000+ 制造商同处一个屋檐下，持证环保电镀，从 CAD 文件到成品全程可追溯。",
      cta: "浏览贸易目录",
    },
    stats: {
      cadReady: "5,000+",
      everyOrder: "制造商同处一个屋檐下",
      phases: "全链覆盖",
      milestone: "铸造 · 镶嵌 · 抛光 · 电镀 · 品控",
      ecoPlating: "环保持证",
      ephCertified: "废水处理设施",
      fullTrace: "全程追踪",
      clientVis: "蜡模到交付",
    },
    orderContents: {
      overline: "您的作品如何制作",
      subtitle: "从文件到成品",
      items: [
        {
          heading: "CAD 到蜡模打印",
          body: "您的生产文件路由至 EPH，转化为实体蜡模母版——从数字设计到实物作品的第一步。",
        },
        {
          heading: "铸造与镶嵌",
          body: "失蜡铸造、宝石镶嵌及组装在同一设施内完成。无跨厂交接，公差零损失。",
        },
        {
          heading: "环保电镀与修饰",
          body: "黄金、铑及合金电镀在持证环保产线完成，厂区内设废水处理设施。抛光及修饰严格按规格执行。",
        },
        {
          heading: "品控与交付",
          body: "出货前多点质量检验。生产里程碑在您的仪表板上即时可见，完成后签发运单。",
        },
      ],
    },
    workflow: {
      overline: "生产阶段",
      subtitle: "您的订单，逐步推进",
      phases: [
        ["订单确认", "您的设计进入 EPH 生产队列"],
        ["NRE 与试铸", "蜡模打印完成，样品提交审批"],
        ["铸造", "金属浇注，重量及合金验证"],
        ["镶嵌与组装", "宝石镶嵌、公差检查、组件装配"],
        ["电镀与修饰", "环保认证电镀按您的规格执行"],
        ["品控与发货", "最终多点检验，签发运单"],
      ],
    },
    eph: {
      overline: "EPH 制造基地",
      location: "中国",
      headline: "5,000+ 制造商。同一屋檐。完整供应链。",
      body: "EPH 是中国最大的一体化珠宝制造基地——也是每一份 Caratzon 订单的专属生产设施。持证废水处理、环保认证电镀产线，加上完整生产链同处一个屋檐下，EPH 为规模化可持续精品珠宝制造树立了行业标杆。",
      attrs: [
        {
          label: "一体化供应链",
          body: "铸造、镶嵌、抛光及电镀在同一设施内完成。无跨厂物流，无交接遗失。",
        },
        {
          label: "持证环保电镀",
          body: "黄金、铑及合金表面处理在环保认证产线完成，厂区内设废水处理设施——已验证减少化学排放。",
        },
        {
          label: "规模与专业化",
          body: "5,000+ 制造商在各珠宝品类拥有深度专业能力，涵盖婚嫁系列至高级定制。",
        },
        {
          label: "直接数字集成",
          body: "CAD 文件从 Caratzon 平台直接路由至 EPH 生产队列——零人工重新录入，全程可追溯。",
        },
      ],
    },
    cta: {
      overline: "浏览目录",
      heading: "看看我们能\n生产什么。",
      primary: "浏览贸易目录",
      secondary: "申请成为制造商 →",
    },
    inquiryForm: {
      overline: "合作伙伴申请",
      heading: "申请加入\n制造网络。",
      subtitle:
        "请告诉我们您的工厂及生产能力。合作团队将审核您的申请并在 3 个工作日内回复。",
      companyName: "公司 / 工厂名称",
      contactName: "主要联系人姓名",
      email: "商务邮箱",
      phone: "电话号码",
      website: "公司网站",
      location: "工厂位置（城市、国家）",
      capabilities: "制造能力",
      capabilitiesHint: "选择所有适用项",
      capabilityOptions: [
        "铸造",
        "镶嵌",
        "电镀",
        "抛光",
        "CAD/CAM",
        "CNC",
        "装配",
        "雕刻",
        "搪瓷",
        "品控 / 检验",
      ],
      specializations: "珠宝专业领域",
      specializationsHint: "选择所有适用项",
      specializationOptions: [
        "戒指",
        "耳环",
        "项链",
        "手链",
        "婚嫁系列",
        "男士系列",
        "腕表",
        "定制",
      ],
      certifications: "认证资质",
      certificationsHint: "选择所有适用项",
      certificationOptions: [
        "RJC",
        "ISO 9001",
        "ISO 14001",
        "Hallmark",
        "Fairmined",
        "BSCI / Sedex",
      ],
      productionCapacity: "每月生产能力（件）",
      capacityOptions: [
        "500 件以下",
        "500 – 2,000",
        "2,000 – 10,000",
        "10,000 – 50,000",
        "50,000+",
      ],
      additionalInfo: "补充信息",
      additionalInfoPlaceholder:
        "其他您希望我们了解的信息——专长、交期、现有合作关系等。",
      submit: "提交申请",
      submitting: "提交中…",
      successHeading: "申请已收到",
      successBody:
        "感谢您有意加入 Caratzon 制造网络。合作团队将审核您的申请，并在 3 个工作日内与您联系。",
      errorRequired: "请填写所有必填字段。",
      errorEmail: "请输入有效的邮箱地址。",
      errorSend: "出现问题，请重试或直接发邮件给我们。",
    },
  },

  partnerApplication: {
    meta: {
      title: "合作伙伴申请 · Caratzon",
      description:
        "申请加入 Caratzon 制造网络。告诉我们您的工厂、生产能力及认证资质。",
    },
  },

  contact: {
    overline: "联系我们",
    meta: {
      title: "联系我们 · Caratzon",
      description: "联系Caratzon团队。与我们的贸易台对话、申请成为设计师或发送一般咨询。",
    },
    heading: "联系Caratzon",
    subtitle: "无论您是寻求独家设计的零售品牌，还是希望将IP变现的3D CAD工程师，我们的全球团队随时为您服务。",
    tabs: {
      brand: "我是品牌/零售商",
      designer: "我是设计师",
      general: "一般/媒体/投资者",
    },
    brand: {
      headline: "与贸易台对话",
      copy: "准备跳过研发、简化制造流程？与我们的采购专家讨论平台访问、大批量采购或EPH制造能力。",
      firstName: "名",
      lastName: "姓",
      workEmail: "工作邮箱",
      companyName: "公司/品牌名称",
      companyWebsite: "公司网站",
      helpWith: "我们能帮您什么？",
      helpOptions: [
        "升级到Source / Atelier套餐",
        "大批量采购",
        "EPH制造能力",
        "Caratzon Studio AI演示",
        "平台一般问题",
      ] as readonly string[],
      selectPlaceholder: "选择主题…",
      message: "留言",
      messagePlaceholder: "请告诉我们您的采购需求、时间线或具体问题…",
      submit: "发送消息",
      submitting: "发送中…",
    },
    designer: {
      headline: "加入Caratzon设计师网络",
      copy: "通过我们的全球许可市场将您的3D CAD珠宝设计变现。上传作品集、设定条款，让品牌主动找到您。",
      firstName: "名",
      lastName: "姓",
      email: "邮箱地址",
      portfolioUrl: "作品集 / Behance / Instagram链接",
      cadSoftware: "主要CAD软件",
      cadOptions: [
        "Rhino / Grasshopper",
        "Matrix / MatrixGold",
        "ZBrush",
        "Blender",
        "SolidWorks",
        "其他",
      ] as readonly string[],
      selectPlaceholder: "选择您的主要工具…",
      designCount: "设计作品大致数量",
      designCountOptions: [
        "1–10",
        "11–50",
        "51–200",
        "200+",
      ] as readonly string[],
      designCountPlaceholder: "选择范围…",
      message: "介绍您的作品",
      messagePlaceholder: "描述您的设计风格、专业领域以及您对许可合作的期望…",
      submit: "申请成为设计师",
      submitting: "发送中…",
    },
    general: {
      headline: "一般咨询",
      copy: "媒体、合作伙伴关系或投资者关系，请联系我们的企业团队。",
      name: "姓名",
      email: "邮箱地址",
      topic: "主题",
      topicOptions: [
        "媒体与新闻",
        "投资者关系",
        "合作伙伴",
        "其他",
      ] as readonly string[],
      selectPlaceholder: "选择主题…",
      message: "留言",
      messagePlaceholder: "我们能为您做什么？",
      submit: "发送咨询",
      submitting: "发送中…",
    },
    success: {
      heading: "消息已收到",
      body: "感谢您的来信。我们的团队将在24小时内回复您。",
      backToHome: "返回首页",
      explorePlatform: "探索平台 →",
    },
    errors: {
      required: "请填写所有必填项。",
      invalidEmail: "请输入有效的邮箱地址。",
      sendFailed: "出了点问题。请重试或直接发送邮件至hello@caratzon.com。",
    },
    offices: {
      heading: "全球办事处",
      hongkong: { city: "香港", label: "亚太贸易台" },
      guangdong: { city: "广东", label: "制造与运营总部" },
      london: { city: "伦敦", label: "欧洲贸易台" },
    },
  },

  about: {
    meta: {
      title: "关于 Caratzon — 我们的故事",
      description:
        "Caratzon 是连接独立珠宝设计师与世界级制造业的全球双边生态系统。了解我们如何变革珠宝供应链。",
    },
    hero: {
      overline: "关于 Caratzon · 成立于 2024 年",
      h1Line1: "卓越设计",
      h1Line2: "在此邂逅",
      h1Line3: "无瑕执行。",
      tagline:
        "Caratzon 源于一封几乎让某珠宝品牌整个假日旺季付诸东流的遗失邮件。今天，我们是连接才华横溢的独立设计师与世界级全程管理制造业的全球双边生态系统。",
      lastUpdated: "最后更新：2026 年 2 月",
    },
    stats: {
      overline: "平台规模",
      subtitle: "数据说话",
      items: [
        { value: "10,000+", label: "独家 CAD 设计" },
        { value: "150+", label: "精选制造合作伙伴" },
        { value: "1M+", label: "生产节点已协调" },
        { value: "$50M+", label: "为创作者创造的收益" },
        { value: "0", label: "黑盒供应链延误" },
      ],
    },
    origin: {
      overline: "我们的起源",
      subtitle: "每个平台都有其创始故事",
      p1: "每一天，Caratzon 都在赋能创作者将艺术变现，同时让 B2B 品牌采购新鲜、独家的系列——以透明、节点化供应链的绝对确定性为保障。",
      p2: "我们的使命是消除全球采购的风险与摩擦。当品牌爱上我们平台上的一件设计时，他们无需烦恼如何制造。Caratzon 全程处理 CAD 工程、实体打样、多供应商物流、质量控制及最终交付——端到端一体管理。",
      digitalDesign: "数字设计",
      precisionCraft: "精密工艺",
    },
    timeline: {
      overline: "Caratzon 的故事",
      subtitle: "四个篇章",
      phases: [
        {
          heading: "断裂的供应链",
          subheading: "故事的起点",
          label: "问题所在",
          body: "一切始于一件设计精妙的多组件作品——需要定制切割的蓝宝石、精确的失蜡铸造以及专业的铑金表面处理。将 CAD 文件路由至横跨两个大洲的三家工厂，却因一家工厂试图隐瞒的细小气孔问题而导致巨大延误。珠宝行业依赖 PDF 发票、微信更新和盲目信任的现状，已然不可持续。",
        },
        {
          heading: "被困的才华",
          subheading: "隐藏在眼前的市场断层",
          label: "核心洞察",
          body: "与此同时，我们意识到市场中存在巨大的断层。才华横溢的独立珠宝设计师拥有满硬盘令人叹为观止的 3D CAD，却完全没有工厂资源或资本去生产它们。而主要的 B2B 零售品牌迫切需要新鲜美学，却对试用未知创作者的制造风险望而却步。艺术与物流，从根本上背道而驰。",
        },
        {
          heading: "铸造操作系统",
          subheading: "打造中枢神经系统",
          label: "建设之路",
          body: "我们决定打造终极桥梁。我们工程化了一个专有的、模块化的、基于节点的平台，作为珠宝制造的中枢神经系统。它被设计为直接将技术设计师的构想与外部工厂相连，实时追踪损益利润率，并保护每一份技术规格——同时让个别供应商完全相互隔离。",
        },
        {
          heading: "终极市集",
          subheading: "设计与无瑕执行的交汇",
          label: "最终成果",
          body: "Caratzon 正式推出，不仅是一款追踪工具，更是一个由全程管理制造引擎支撑的精选设计师市集。今天，当品牌爱上我们平台上的一件设计时，他们无需烦恼如何制造。点击一次，Caratzon 自动将设计路由至我们精选的网络，处理 CAD 工程、实体打样及最终质量控制。",
        },
      ],
    },
    vision: {
      overline: "愿景与使命",
      visionLabel: "我们的愿景",
      visionBody:
        "成为世界级珠宝设计与无瑕执行无缝交汇的权威全球生态系统——将碎片化的供应链转化为对创作者和品牌均高度盈利的透明引擎。",
      missionLabel: "我们的使命",
      missionBody:
        "通过将独立珠宝设计师的艺术与全球 B2B 品牌相连，赋能设计师——以我们全程管理的制造操作系统作为无缝后盾。我们的存在是为了消除全球采购的风险与摩擦。",
    },
    howItWorks: {
      overline: "平台运作方式",
      subtitle: "一键操作。端到端完成。",
      steps: [
        {
          heading: "设计师上传",
          body: "独立设计师上传 CAD 文件、设定 IP 条款并发布编辑故事。他们的作品受带签名、有时效的查看 URL 保护。",
        },
        {
          heading: "品牌探索",
          body: "零售品牌在精选目录中浏览 10,000+ 件独家设计，通过平台内互动式 3D 查看器预览作品。",
        },
        {
          heading: "Caratzon 路由",
          body: "达成协议后，我们的节点引擎自动将设计路由至精选制造网络——CAD 工程、打样、品控全程处理。",
        },
        {
          heading: "以利润交付",
          body: "实时损益可视化、里程碑追踪及最终交付——零黑盒延误，全程供应链完全透明。",
        },
      ],
    },
    leadership: {
      overline: "管理团队",
      founderRole: "创始人兼首席执行官",
      founderName: "[创始人姓名]",
      founderBio:
        "请在此简述您在珠宝设计、供应链管理及科技领域的背景——以及驱动 Caratzon 愿景的力量。",
      tags: ["珠宝设计", "供应链", "科技"],
    },
    supplyChain: {
      overline: "供应链架构",
      heading: "节点化架构。\n完全透明。",
      items: [
        {
          title: "供应商完全隔离",
          desc: "个别工厂节点独立运作，任何供应商均无法查看其他供应商的规格、定价或产能数据。",
        },
        {
          title: "实时损益追踪",
          desc: "每个生产里程碑的利润可视化——设计师、品牌及管理者只能看到与其角色相关的数据。",
        },
        {
          title: "不可篡改的审计追踪",
          desc: "每个 CAD 版本、审批及生产事件均有时间戳并记录在案——完整的监管链，触手可及。",
        },
      ],
    },
    quote: {
      text: "「艺术与物流，从根本上背道而驰。\n我们建造了这座桥。」",
      attribution: "Caratzon · 创始理念",
    },
    cta: {
      overline: "与 Caratzon 合作",
      heading: "共建\n精品珠宝的未来。",
      primary: "浏览目录",
      secondary1: "品牌商及零售商 →",
      secondary2: "独立设计师 →",
    },
  },

  forStudio: {
    meta: {
      title: "Caratzon Studio · Where AI Meets the Jeweler's Bench",
      description: "The AI-powered design workspace for jewelry creators. Meet Cara — your design assistant that thinks in millimeters, Mohs hardness, and tensile strength.",
    },
    hero: {
      overline: "Caratzon Studio",
      h1Line1: "Your Designs",
      h1Line2: "Deserve an Atelier.",
      tagline: "Caratzon Studio is the AI-powered workspace where independent jewelry designers upload CAD, tell their story, and let the platform handle everything else — marketing, licensing, production routing, and now, intelligent design assistance.",
      cta: "Apply as a Designer →",
      ctaSecondary: "See Pricing →",
    },
    stats: {
      aiAssisted: "AI-Assisted",
      designTools: "Design Tools",
      stoneTypes: "50+",
      stoneLabel: "Stone & Alloy Database",
      phases: "6",
      phasesLabel: "Sketch-to-Sales Steps",
      renders: "Instant",
      rendersLabel: "Catalog Renders",
    },
    cara: {
      overline: "Meet Cara",
      subtitle: "From Sketch to Sales",
      heading: "From Napkin Sketch\nTo Global Sales.",
      p1: "Cara is the AI design assistant that turns a hand-drawn sketch into a production-ready, market-listed piece of jewelry — handling every step from concept clarification to catalog renders, storytelling, and trade listing.",
      p2: "Snap a photo of your sketch. Cara asks the right questions — materials, dimensions, stone placement — then renders a faithful concept that respects your original vision down to every curve and proportion.",
      pipeline: [
        { num: "01", label: "Sketch", heading: "Upload Your Sketch", body: "Photograph a hand-drawn sketch or napkin doodle. Cara's vision model analyzes silhouettes, proportions, stone placements, and decorative details — extracting your intent with surgical precision.", icon: "pencil" },
        { num: "02", label: "Clarify", heading: "Intelligent Q&A", body: "Before touching a single pixel, Cara asks clarifying questions — metal type, stone cuts, ring size, finish preferences. Your answers become the design brief that locks in fidelity.", icon: "message-circle" },
        { num: "03", label: "Render", heading: "Faithful AI Render", body: "Cara generates a photorealistic concept that replicates your sketch with extreme fidelity — same silhouette, same proportions, same stone placement. Iterate through conversation until it's perfect.", icon: "image" },
        { num: "04", label: "Save", heading: "Save to Studio", body: "One click saves the approved render into your Studio as a new design draft — complete with the original sketch, conversation history, and all design parameters for future refinement.", icon: "save" },
        { num: "05", label: "Story", heading: "The Making Narrative", body: "Your sketch and the entire Cara conversation become the raw material for an AI-generated 'Making Of' story — a compelling editorial narrative that traces the creative journey from first line to final render.", icon: "book-open" },
        { num: "06", label: "Sell", heading: "List & Earn", body: "Catalog renders, lookbook assets, and trade listings are generated automatically. Your design enters the global catalog where brands discover, license, and order — and you earn 80% on every transaction.", icon: "trending-up" },
      ],
      conversationDemo: {
        label: "Cara — Sketch-to-Concept",
        userSketch: "I sketched this cocktail ring — can you turn it into a real concept?",
        caraAnalysis: "I can see a bold asymmetric band with what looks like a tension-set center stone and tapered shoulders. Before I render, let me clarify a few things:",
        caraQuestions: [
          "What metal are you envisioning? The angular lines suggest platinum or white gold",
          "The center stone — is that an emerald cut? Approximately what carat weight?",
          "I see texture marks on the band — brushed finish or hammered?",
        ],
        userReply: "Platinum, 2ct emerald-cut emerald, brushed finish on the band.",
        caraConfirm: "Perfect. Rendering your concept now — same silhouette, same proportions, platinum with brushed finish and a 2ct emerald-cut emerald in tension setting…",
        toolLabel: "Rendering faithful concept…",
      },
      cta: "Try Cara in Studio →",
    },
    storyLab: {
      overline: "AI Story Lab",
      subtitle: "Automated Storytelling",
      heading: "Your Story,\nTold Beautifully.",
      p1: "Answer seven guided questions during onboarding and our AI generates a rich editorial-style designer story, profile page, and lookbook — the kind of content that used to require a copywriter, photographer, and art director.",
      p2: "Each designer gets a dedicated Inspire profile where buyers discover your work through AI-generated narratives, not generic product listings.",
      features: [
        { label: "Editorial Profiles", description: "AI-generated designer stories that read like magazine features — not template bios." },
        { label: "AI Lookbooks", description: "Cohesive visual narratives across your portfolio, generated automatically from your designs." },
        { label: "Collection Storytelling", description: "Group pieces into themed collections and let AI weave a narrative across the set." },
      ],
    },
    workspace: {
      overline: "Designer Workspace",
      subtitle: "Everything in One Place",
      heading: "Upload. Manage.\nEarn.",
      p1: "The Studio workspace is your command center — upload CAD files, track licensing revenue, manage collections, monitor analytics, and communicate with buyers. All from one dashboard.",
      features: [
        { num: "01", heading: "3D Viewer", body: "Buyers inspect your designs in full 3D before licensing. Your CAD files are never exposed — only renders and previews." },
        { num: "02", heading: "Revenue Dashboard", body: "Track licensing fees, royalties, and production runs in real time. 80% revenue share on every license." },
        { num: "03", heading: "IP Protection", body: "CAD files are vault-encrypted and never shown to buyers. Structured licensing tiers with clear terms." },
        { num: "04", heading: "Direct Messaging", body: "Communicate with buyers and production managers directly inside the platform." },
      ],
    },
    revenue: {
      overline: "Revenue Models",
      subtitle: "Three Licensing Tiers",
      heading: "Earn on\nYour Terms.",
      models: [
        { tier: "standard", label: "Standard License", heading: "Non-Exclusive", description: "Multiple buyers can license the same design. You keep 80% of the licensing fee plus perpetual royalties on every production run.", benefit: "80% + Perpetual Royalties" },
        { tier: "embargo", label: "Seasonal Embargo", heading: "12-Month Exclusive", description: "One buyer gets competitor-proof exclusivity for a year. Higher upfront payment. After 12 months, the design returns to Standard availability.", benefit: "80% + Premium Exclusivity Fee" },
        { tier: "vault", label: "Full Exclusive", heading: "Permanent IP Transfer", description: "One-time buyout with permanent IP transfer including the CAD file. The highest upfront payment. Caratzon Kit included.", benefit: "Full Buyout + Caratzon Kit" },
      ],
    },
    steps: {
      overline: "Getting Started",
      subtitle: "Three Steps",
      items: [
        { heading: "Apply & Onboard", body: "Complete the seven-question onboarding flow. Our AI generates your editorial profile, designer story, and Inspire page automatically." },
        { heading: "Upload & Create", body: "Upload CAD files. Use Cara to refine designs, run structural analysis, and generate catalog-ready renders. Organize pieces into collections." },
        { heading: "Earn & Grow", body: "Buyers discover, license, and order your designs. You earn 80% on every license. Production is handled by our EPH-certified manufacturing hub." },
      ],
    },
    cta: {
      overline: "Join the Studio",
      heading: "Design the Future.\nWe Handle the Rest.",
      primary: "Apply as a Designer →",
      secondary: "Explore the Catalog →",
    },
  },

  studio: {
    nav: { guide: "指南", inbox: "收件箱", storyLab: "我的设计", collections: "作品集", cara: "Cara", publishing: "发布管理", admin: "管理后台 →", catalog: "← 目录", analytics: "数据分析" },
    notifications: { heading: "通知", empty: "暂无通知。" },
    cara: {
      title: "Cara",
      subtitle: "AI设计助手",
      newSession: "新设计会话",
      placeholder: "描述您的愿景，或上传灵感图片…",
      emptyTitle: "认识Cara",
      emptyDescription: "您的AI设计助手——集珠宝大师与机械工程师于一身。描述您的愿景或上传灵感图片开始。",
      analyzing: "正在分析灵感…",
      rendering: "正在生成设计渲染…",
      structuralAnalysis: "正在运行可制造性模拟…",
      calculatingBom: "正在计算物料清单…",
      generatingVideo: "正在生成旋转预览——最多可能需要一分钟…",
      processing: "处理中…",
      phases: { spark: "灵感", architect: "构造", crucible: "验证", bench: "定稿" },
      artifacts: {
        title: "制品",
        empty: "Cara生成的制品将显示在此处。",
        moodBoards: "情绪板",
        renders: "设计渲染",
        structuralAnalysis: "结构分析",
        materialAnalysis: "材料分析",
        bom: "物料清单",
        videos: "视频",
      },
      sessions: { empty: "暂无会话", emptyHint: "开始您与Cara的第一个设计会话", untitled: "未命名会话" },
      errors: { streamFailed: "出了点问题，请重试。", rateLimited: "消息发送过快，请稍候。" },
    },
    gettingStarted: {
      overline: "设计师工作室",
      title: "入门指南",
      subtitle: "三大核心工作室功能的可视化导览——在开始之前了解完整流程。",
      howItWorks: {
        title: "运作方式",
        steps: [
          {
            title: "上传与创建",
            label: "我的设计",
            body: "上传您的 CAD 文件及辅助素材，然后让 AI 为您的设计生成可发布的目录故事。",
          },
          {
            title: "回应请求",
            label: "收件箱",
            body: "品牌提交定制请求。您可以协商条款、交付修改版 CAD 文件——一切均在同一对话中追踪。",
          },
          {
            title: "策划作品集",
            label: "作品集",
            body: "将已发布的设计组织成主题式编辑作品集。AI 会将各个设计故事编织成连贯的叙事。",
          },
        ],
      },
      storyLabWorkflow: {
        title: "设计工作流程",
        subtitle: "两个阶段将您的 CAD 文件转化为已发布的灵感页面。",
        phase1: {
          title: "第一阶段 — 设计草稿",
          subtitle: "五步向导收集平台在 AI 接手前所需的一切信息。",
          steps: [
            { title: "身份", body: "为您的作品命名并撰写简短描述。" },
            { title: "定价与规格", body: "设定基础授权价格、金属重量和宝石数量。" },
            { title: "知识产权保护", body: "选择标准授权、季节性独家或完全独家权利。" },
            { title: "上传素材", body: "上传生产 CAD、3D 预览文件和主图渲染。" },
            { title: "审核与创建", body: "确认所有信息并创建设计草稿。" },
          ],
        },
        phase2: {
          title: "第二阶段 — AI 故事",
          subtitle: "六个步骤将您的草稿转化为附有 AI 生成叙事和图像的目录故事。",
          steps: [
            { title: "灵感关键词", body: "上传参考照片；AI 分析情绪、材质和主题。" },
            { title: "选择关键词", body: "选择最能捕捉作品灵魂的词语。" },
            { title: "生成故事", body: "描述材质和设计意图；AI 撰写目录叙事。" },
            { title: "修改故事", body: "编辑 AI 草稿——买家将阅读这段文字。" },
            { title: "生成展示", body: "AI 构建包含章节、标题和图像位的目录版面。" },
            { title: "提交审批", body: "锁定编辑并发送至审核团队。" },
          ],
        },
      },
      afterSubmission: {
        title: "提交后会发生什么",
        body: "管理员将审核您的故事和展示。您将收到决定通知——已批准的设计将在贸易目录中上线，被退回的提交将附带修改意见返回给您。",
        steps: [
          { label: "已提交", body: "您的设计进入审核队列。" },
          { label: "已审核", body: "管理员评估故事质量和素材完整性。" },
          { label: "已发布", body: "已批准的设计出现在贸易目录中供品牌发现。" },
        ],
      },
      fileRequirements: {
        title: "文件要求",
        subtitle: "接受格式和大小限制速查表。",
        columns: { asset: "素材", formats: "格式", maxSize: "大小上限", required: "必需" },
        rows: [
          { asset: "生产 CAD", formats: ".stl, .3dm, .step", maxSize: "50 MB", required: "是" },
          { asset: "3D 预览", formats: ".glb", maxSize: "25 MB", required: "是" },
          { asset: "主图渲染", formats: ".jpg, .png, .webp", maxSize: "10 MB", required: "是" },
          { asset: "参考照片", formats: ".jpg, .png, .webp", maxSize: "每张 5 MB", required: "可选" },
        ],
      },
      ipTiers: {
        title: "知识产权层级说明",
        subtitle: "三种授权模式——选择适合您目标的方案。",
        tiers: [
          {
            title: "标准授权",
            body: "您的 CAD 由 Caratzon 保管，仅在保密协议下向认证制造商发放。您可获得每笔授权费的 80% 加永久版税。多个品牌可同时授权。",
          },
          {
            title: "季节性独家",
            body: "一个品牌持有 12 个月的独家权利。设计在其独家期间隐藏，独家期结束后重返市场。适用高级定价。",
          },
          {
            title: "完全独家权利",
            body: "品牌永久获得完整知识产权。您的生产 CAD 直接转让给他们。一次性高价值交易——设计永久从市场下架。",
          },
        ],
      },
      cta: {
        title: "准备好开始了吗？",
        button: "创建您的第一个设计",
      },
    },
    storyLab: {
      overline: "设计师工作室",
      title: "我的设计",
      subtitle: "上传设计、生成 AI 故事，并发布到您的灵感页面。",
      newDraft: "新建设计草稿",
      overlineLabel: "我的设计",
      cancel: "取消",
      continue: "继续",
      back: "返回",
      stepOf: "第 {current} 步，共 {total} 步",
      keyboardHint: "提示：按 Alt + 方向键可在步骤之间导航",
      editing: "编辑中…",
      draftInProgress: "草稿进行中",
      emptyTitle: "暂无设计",
      emptySubtitle: "上传您的第一个设计，开始构建您的灵感作品集。",
      newDesign: "新建设计",
      emptyHint: "或从侧边栏选择一个已有设计",
      batchUpload: "批量上传",
      batchUploadSubtitle: "拖放最多 20 张珠宝照片——AI 为每件作品生成标题、描述和关键词",
      batchProcessing: "正在处理 {count} 件作品…",
      batchGenerate: "生成 {count} 个设计",
      batchCreated: "已创建 {count} 个设计",
      batchDuplicates: "跳过 {count} 个重复项",
      batchPossibleDuplicates: "{count} 个可能重复",
      batchFailed: "{count} 个失败",
      batchDuplicateExact: "已上传为「{title}」",
      batchDuplicateNear: "可能与「{title}」相似（{confidence}% 匹配）",
      batchViewInLab: "在我的设计中查看",
      batchDropHere: "将最多 20 张珠宝照片拖放至此",
      batchDropHint: "AI 将为每件作品生成标题、描述和关键词",
      celebrationTitle: "设计草稿已创建！",
      celebrationSubtitle: "您的设计已准备好。从下方的关键词生成开始构建其故事。",
      selectDesign: "选择一个设计\n以继续",
      selectDesignHint: "从面板中选择一个草稿，或创建新设计。",
      sidebar: { newDesign: "+ 新建设计", designs: "设计列表", noDesigns: "暂无设计" },
      steps: {
        identity: {
          title: "为作品命名",
          subtitle: "为您的设计取一个标题并撰写简短描述，捕捉其精髓。这是买家看到的第一印象。",
          designTitle: "设计标题",
          titleTip: "此标题将成为 Caratzon 市场上的公开名称。请保持富有意境且令人难忘——买家首先按标题浏览。",
          titlePlaceholder: "例如 Lunette Drop Earrings",
          titleHint: "选择一个能体现作品精髓的名称",
          description: "简要描述",
          descriptionPlaceholder: "用一两句话描述作品及其特质。",
          descriptionHint: "此描述将显示在目录中。请保持富有意境且简洁。",
        },
        pricing: {
          title: "定价与规格",
          subtitle: "设定您的基础授权价格并提供材料规格。这些信息帮助买家评估成本，并协助制造商准备生产报价。",
          basePrice: "基础价格（美元）",
          basePriceTip: "这是您的授权费用。品牌支付此金额使用您的设计。扣除平台费用后，您可获得 80%。",
          basePriceHint: "品牌为使用您的设计支付的授权费用。您可获得 80%。",
          metalWeight: "金属重量（克）",
          metalWeightTip: "大致重量有助于制造商估算生产成本并提供准确报价。",
          metalWeightHint: "设计中金属的大致重量",
          stoneCount: "宝石数量",
          stoneCountHint: "作品中镶嵌的宝石总数",
          howPricingWorks: "定价机制说明：",
          howPricingBody: "您的基础价格即设计授权费。制造成本由经审核的工厂根据金属重量、宝石及复杂度另行报价。",
        },
        licensing: {
          title: "选择 IP 保护方式",
          subtitle: "选择品牌可以如何使用您的设计。每个层级提供不同的保护级别和收益模式。",
          licensingTip: "您的 IP 层级决定了品牌如何使用您的设计。标准授权允许多方授权；独家授权赋予单一品牌临时专有权；完整独家版权则转让全部所有权。",
          standard: "标准授权",
          standardDesc: "您的 CAD 文件由 Caratzon 保管，仅在 NDA 保密协议下发放给经审核的制造商。您可获得每笔授权费的 80% 及持续版税。",
          standardDetail: "最适合希望获得持续被动收入的设计师。多个品牌可同时授权。",
          exclusive: "季节性独家授权",
          exclusiveDesc: "单一品牌享有 12 个月的独家权利。独家窗口期内设计从市场隐藏。独家期结束后重新上架。",
          exclusiveDetail: "独家授权享有溢价定价。品牌为独家窗口期支付更高的授权费。",
          vault: "完整独家版权",
          vaultDesc: "品牌永久获得完整 IP。您的生产 CAD 文件将直接转让给对方。您可获得收购价的 80%。",
          vaultDetail: "一次性高价交易。设计将从市场永久下架。",
          ipTransfer: "IP 转让",
        },
        assets: {
          title: "上传您的文件",
          subtitle: "上传买家和制造商所需的设计文件。您的生产 CAD 文件受到保护——仅经审核的制造商可在 NDA 下查看。",
          assetsTip: "您的生产 CAD 文件绝不会分享给买家。仅 Caratzon 审核通过的制造商可在严格 NDA 条款下获取。",
          requiredFiles: "必需文件",
          optionalFiles: "可选——可提升 AI 故事质量",
          vaultNotice: "完整独家版权。",
          vaultNoticeDetail: "您的 CAD 文件将直接转让给收购品牌。",
          cadProtected: "CAD 文件受 IP 保护。",
          cadProtectedDetail: "仅 Caratzon 审核通过的制造商可在 NDA 下获取。",
          cadLabel: "生产 CAD 文件",
          cadLabelVault: "用于 IP 转让的生产 CAD 文件",
          cadHint: ".stl · .3dm · .step — 您的源文件，绝不向买家披露",
          viewerLabel: "3D 查看器资源",
          viewerHint: ".glb — 从 CAD 导出的文件，用于买家互动预览",
          renderLabel: "2D 渲染图 / 主图",
          renderHint: ".jpg · .png · .webp — 目录中的主缩略图",
        },
        review: {
          title: "审核并创建",
          submit: "创建设计草稿",
          submitting: "创建中…",
          identity: "身份信息",
          pricingSpecs: "定价与规格",
          licensingTier: "授权层级",
          assets: "文件资源",
          edit: "编辑",
          uploaded: "已上传",
          missing: "缺失",
          allRequired: "创建前必须上传所有必需文件。",
        },
      },
      workflow: {
        featured: "精选",
        revisionRequired: "需要修改",
        revisionHint: "请处理上述反馈意见，然后重新提交。",
        noReason: "未提供原因。",
        step01: "灵感关键词",
        step01Sub: "上传参考照片并添加背景说明。AI 分析氛围、材料和主题，生成关键词组合。",
        additionalContext: "补充说明",
        contextPlaceholder: "例如 Art Deco 风格、午夜蓝宝石…",
        generateKeywords: "生成关键词",
        regenerateKeywords: "重新生成关键词",
        analysingRefs: "正在分析参考图片…",
        step02: "选择关键词",
        step02Sub: "选择最能捕捉作品灵魂的词语——它们是 AI 生成故事的锚点。",
        saveKeywords: "保存已选关键词",
        saving: "保存中…",
        step03: "生成故事",
        step03Sub: "描述材料、设计意图和隐含寓意。AI 将撰写显示在您目录页面上的叙事。",
        pieceDescription: "作品描述",
        describePlaceholder: "描述这件设计",
        materialsColors: "材料与色彩",
        materialsPlaceholder: "精银、密镶钻石…",
        initialSpark: "最初灵感",
        sparkPlaceholder: "一张图片、一段记忆或一种氛围…",
        hiddenSymbolism: "隐含象征",
        symbolismPlaceholder: "这件作品中编码了什么寓意？",
        generateStory: "生成故事",
        regenerateStory: "重新生成故事",
        writingStory: "正在撰写您的故事…",
        step04: "润色故事",
        step04Sub: "审核 AI 草稿。自由编辑标题和正文——此文本将展示给目录页面上的买家。",
        saveStory: "保存故事",
        step05: "生成展示页面",
        step05Sub: "AI 构建目录版面——板块数量、图片位置和标题。全部基于您的故事生成。",
        currentLayout: "当前布局：",
        sections: "个板块",
        generatedImages: "张生成图片",
        generatedImagesPlural: "张生成图片",
        regenerateWarning: "重新生成将替换当前布局。",
        generateShowcase: "生成展示页面",
        regenerateShowcase: "重新生成展示页面",
        buildingShowcase: "正在构建展示页面…",
        step06: "提交审核",
        step06Sub: "锁定进一步编辑，等待管理员审核您的故事和展示页面。审核结果将通知您。",
        awaitingReview: "您的设计已提交至审核团队。审核结果出来后您将收到通知。",
        submitForApproval: "提交审核",
        awaitingAdmin: "等待管理员审核…",
        published: "已发布",
        submitting: "提交中…",
        viewPublished: "查看已发布的故事",
      },
      upload: {
        dragOrClick: "拖拽至此或",
        clickToBrowse: "点击浏览",
        maxSize: "最大 {size} MB",
        required: "必需",
        uploading: "正在上传 {name}…",
        replace: "替换",
        retry: "重试",
        demoPreLoaded: "演示文件已预加载",
        photoRefs: "参考照片",
        photoRefsHint: "— 可选，可提升 AI 质量",
        dragOrClickPhotos: "拖拽或点击添加参考照片",
        upToPhotos: "最多 {max} 张照片",
        remove: "移除",
        inspirationNotes: "灵感备注",
        inspirationPlaceholder: "一段记忆、一种氛围、一份情感线索或特定灵感。",
      },
    },
    collections: {
      overline: "设计师工作室",
      title: "作品集",
      subtitle: "将已发布的设计分组为策划系列，配以AI生成的编辑故事。",
      newCollection: "新建作品集",
      emptyTitle: "您的第一个作品集",
      emptySubtitle: "选择两件或以上已发布的设计来创建作品集。AI将编织它们的故事。",
      emptyHint: "或从侧栏选择现有作品集",
      celebrationTitle: "作品集已创建！",
      celebrationSubtitle: "您的作品集已准备就绪。从下方的关键词生成开始。",
      sidebar: { collections: "作品集", noCollections: "尚无作品集" },
      designPicker: {
        title: "作品集作品",
        subtitle: "选择要包含的已发布设计。您至少需要2件设计。",
        selected: "已选 {count} 件",
        minRequired: "请至少选择2件设计",
        saveDesigns: "保存作品",
        saving: "保存中…",
      },
      create: {
        title: "创建作品集",
        collectionTitle: "作品集标题",
        titlePlaceholder: "例如：午夜海洋系列",
        description: "简短描述",
        descriptionPlaceholder: "几句关于作品集主题的描述。",
        selectDesigns: "选择设计",
        selectDesignsHint: "从已发布的设计中选择至少2件",
        inspirationNote: "灵感备注",
        inspirationNotePlaceholder: "什么将这些作品联系在一起？",
        submit: "创建作品集",
        submitting: "创建中…",
      },
      draftNotInitialized: "作品集草稿尚未初始化。",
      draftNotInitializedCta: "返回作品集",
      workflow: {
        step00: "作品集作品",
        step00Sub: "管理此作品集中包含的设计。",
        step01: "作品集关键词",
        step01Sub: "AI分析所有作品，寻找统一的主题、图案和氛围。",
        additionalContext: "附加上下文",
        contextPlaceholder: "例如：共同的创作季节、材料色调、情感主线…",
        generateKeywords: "生成关键词",
        regenerateKeywords: "重新生成关键词",
        analysingCollection: "分析作品集中…",
        step02: "选择关键词",
        step02Sub: "选择最能捕捉这个作品集灵魂的词汇。",
        saveKeywords: "保存选定关键词",
        saving: "保存中…",
        step03: "生成作品集故事",
        step03Sub: "AI将各设计故事编织成连贯的作品集叙事。",
        generateStory: "生成故事",
        regenerateStory: "重新生成故事",
        writingStory: "撰写作品集故事中…",
        step04: "修改故事",
        step04Sub: "审阅并编辑生成的作品集叙事。",
        saveStory: "保存故事",
        step05: "生成展示页面",
        step05Sub: "AI为每个版块设计多作品编辑展示页面及图片。",
        currentLayout: "当前版面：",
        sections: "个版块",
        generatedImages: "张生成图片",
        generatedImagesPlural: "张生成图片",
        regenerateWarning: "重新生成将替换当前版面。",
        generateShowcase: "生成展示页面",
        regenerateShowcase: "重新生成展示页面",
        buildingShowcase: "构建展示页面中…",
        step06: "提交审核",
        step06Sub: "锁定进一步编辑，直到管理员审核您的作品集故事和展示页面。",
        awaitingReview: "您的作品集已提交审核团队。决定做出后您将收到通知。",
        submitForApproval: "提交审核",
        awaitingAdmin: "等待管理员审核…",
        published: "已发布",
        submitting: "提交中…",
        viewPublished: "查看已发布的作品集",
        revisionRequired: "需要修改",
        revisionHint: "根据以上反馈进行修改，然后重新提交。",
        noReason: "未提供原因。",
        featured: "精选",
      },
    },
    inbox: {
      title: "定制收件箱",
      subtitle: "洽谈条款、审阅需求说明，并上传修改版 CAD 文件。",
      overline: "设计师工作室",
      openRequests: "待处理请求",
      emptyTitle: "暂无活跃请求",
      emptySubtitle: "当品牌为您的设计提交定制请求时，它将显示在这里。",
      selectRequest: "从侧边栏选择一个请求以开始。",
      thread: "对话记录",
      noMessages: "暂无消息。",
      updateStatus: "更新状态",
      uploadRevision: "上传 CAD 修改版",
      revisionHint: "将请求状态移至「进行中」以启用 CAD 修改版上传。",
    },
    analytics: {
      overline: "工作室",
      title: "设计数据分析",
      subtitle: "追踪您的设计表现 — 浏览量、互动率及受众触及率。",
      cards: {
        totalViews: "总浏览量",
        uniqueVisitors: "独立访客",
        avgTimeOnPage: "平均停留时间",
        quoteRequests: "报价请求",
      },
      table: {
        design: "设计",
        views: "浏览量",
        uniqueViews: "独立访客",
        clicks: "点击数",
        avgTime: "平均时长",
        scrollDepth: "滚动深度",
      },
      drillDown: {
        viewsTrend: "浏览趋势（30 天）",
        clickBreakdown: "点击分布",
        referrerBreakdown: "流量来源",
      },
      empty: "暂无数据分析。当您的设计发布并获得浏览后，指标将在此显示。",
      seconds: "秒",
    },
  },

  catalog: {
    overline: "贸易目录",
    resultCount: "{count} 个结果",
    designCount: "{count} 件设计",
    emptyTitle: "目录正在精选策划中",
    emptySubtitle: "设计师正在准备首批作品集。请稍后再来。",
    searchEmptyTitle: "未找到匹配结果",
    searchEmptySubtitle: "尝试不同的搜索词或浏览所有设计。",
    browseCta: "浏览所有设计",
  },

  orders: {
    overline: "贸易工作区",
    title: "采购订单",
    subtitle: "追踪进行中的洽谈、审阅设计师提交的 3D 修改版，并批准提交进入生产路由。",
    activeOrders: "进行中订单",
    emptyTitle: "尚无采购订单",
    emptyCta: "浏览贸易目录 →",
    selectOrder: "选择一个订单以查看洽谈记录。",
    latestRevision: "最新 CAD 修改版 — 3D 预览",
    awaitingRevision: "等待设计师提交首份 CAD 修改版。",
    respondToDesigner: "回复设计师",
  },

  admin: {
    brand: "管理后台",
    nav: { workflows: "工作流程", publishing: "发布管理", users: "用户管理", academy: "学院", developer: "Developer", queues: "队列监控", catalog: "目录", studio: "工作室", analytics: "数据分析", catalogAdmin: "设计目录", catalogListings: "贸易上架", inspireAdmin: "灵感展示", storyLab: "我的设计" },
    users: {
      overline: "管理后台",
      title: "用户管理",
      subtitle: "创建、编辑和管理所有角色的用户账户。",
      tabs: { users: "用户列表", createNew: "新建用户" },
      stats: { total: "用户总数", active: "活跃", suspended: "已停用", designers: "设计师" },
      search: "按姓名或邮箱搜索…",
      allRoles: "所有角色",
      noMatch: "没有符合筛选条件的用户。",
      columns: { name: "姓名", email: "邮箱", role: "角色", status: "状态", actions: "操作" },
      statusActive: "活跃",
      statusSuspended: "已停用",
      edit: "编辑",
      suspend: "停用",
      reactivate: "重新激活",
      roles: {
        DESIGNER: "设计师",
        B2B_BUYER: "品牌 / 买家",
        MANUFACTURER: "制造商",
        PRODUCTION_MANAGER: "生产经理",
        ADMIN: "管理员",
      },
      roleLabels: { DESIGNER: "设计师", B2B_BUYER: "品牌", MANUFACTURER: "工厂", PRODUCTION_MANAGER: "生产经理", ADMIN: "管理员" },
      create: {
        title: "创建账户",
        subtitle: "添加新的设计师、买家、制造商或内部成员。",
        name: "姓名",
        namePlaceholder: "例如 Aria Atelier",
        email: "邮箱地址",
        emailPlaceholder: "designer@example.com",
        password: "密码",
        passwordPlaceholder: "最少 8 个字符",
        role: "角色",
        submit: "创建账户",
      },
      invite: {
        title: "发送邀请链接",
        subtitle: "为指定邮箱和角色生成注册链接。有效期 7 天。",
        email: "邮箱",
        emailPlaceholder: "new-designer@example.com",
        role: "角色",
        submit: "生成链接",
        copied: "已复制！",
        copy: "复制",
      },
      editDialog: {
        title: "编辑用户",
        subtitle: "更新账户详情和角色分配。",
        name: "姓名",
        email: "邮箱",
        role: "角色",
        save: "保存更改",
        cancel: "取消",
        stripe: "Stripe",
        accountActions: "账户操作",
        resetPassword: "重置密码",
        deleteAccount: "删除账户",
      },
      confirm: {
        suspendTitle: "停用用户",
        suspendDesc: "确定停用 {name}？该用户将立即失去平台访问权限。",
        suspendButton: "停用",
        reactivateTitle: "重新激活用户",
        reactivateDesc: "确定重新激活 {name}？该用户将恢复完整访问权限。",
        reactivateButton: "重新激活",
        deleteTitle: "删除用户",
        deleteDesc: "确定永久删除 {name}？此操作无法撤销，所有关联数据将被移除。",
        deleteButton: "永久删除",
        cancel: "取消",
      },
      success: {
        created: "用户账户创建成功。",
        updated: "用户详情已更新。",
        suspended: "用户账户已停用。",
        reactivated: "用户账户已重新激活。",
        deleted: "用户账户已删除。",
        reset: "临时密码已生成。",
        invited: "邀请链接已生成。",
      },
      tempPasswordHint: "请立即复制——此密码不会再次显示。",
      dismiss: "关闭",
    },
    setup: {
      title: "平台设置",
      subtitle: "创建首个管理员账户以开始使用。",
      steps: { authorize: "授权", credentials: "账户信息", designer: "设计师", confirm: "确认" },
      setupPasswordLabel: "设置密码",
      setupPasswordPlaceholder: "输入设置密码",
      setupPasswordHint: "此实例需要设置密码才能创建首个管理员账户。",
      setupPasswordInvalid: "设置密码不正确。",
      emailLabel: "邮箱地址",
      emailPlaceholder: "admin@company.com",
      nameLabel: "全名",
      namePlaceholder: "张三",
      passwordLabel: "密码",
      passwordPlaceholder: "最少 8 个字符",
      confirmPasswordLabel: "确认密码",
      confirmPasswordPlaceholder: "重新输入密码",
      designerTitle: "设计师账户",
      designerSubtitle: "创建首个设计师账户，让其开始上传设计。",
      designerNameLabel: "设计师名称",
      designerNamePlaceholder: "Aria Atelier",
      designerEmailLabel: "设计师邮箱",
      designerEmailPlaceholder: "designer@company.com",
      designerPasswordLabel: "设计师密码",
      designerPasswordPlaceholder: "最少 8 个字符",
      reviewTitle: "审核",
      reviewSubtitle: "确认将创建的账户。",
      createAccount: "创建账户",
      back: "返回",
      next: "下一步",
      passwordMismatch: "密码不一致。",
      passwordTooShort: "密码最少需要 8 个字符。",
    },
    analytics: {
      overline: "管理后台",
      title: "平台数据分析",
      subtitle: "全平台设计互动指标及成效分析。",
      cards: {
        totalViews: "总浏览量",
        uniqueVisitors: "独立访客",
        avgTimeOnPage: "平均停留时间",
        totalClicks: "总点击数",
      },
      filters: {
        designer: "按设计师筛选",
        dateRange: "日期范围",
        allDesigners: "所有设计师",
      },
      leaderboard: "表现最佳设计",
      zeroEngagement: "需要关注（零互动）",
      table: {
        design: "设计",
        designer: "设计师",
        views: "浏览量",
        uniqueViews: "独立访客",
        clicks: "点击数",
        avgTime: "平均时长",
        scrollDepth: "滚动深度",
      },
      drillDown: {
        viewsTrend: "浏览趋势",
        clickBreakdown: "点击分布",
        referrerBreakdown: "流量来源",
      },
      empty: "暂无数据分析。当设计发布并获得浏览后，指标将在此显示。",
      seconds: "秒",
    },
  },

  messages: {
    overline: "通讯",
    title: "消息",
    subtitle: "与设计师、生产经理及制造合作伙伴的对话。",
    emptyTitle: "暂无对话",
    emptyCta: "浏览目录以开始",
    typeMessage: "输入消息...",
    send: "发送",
    translate: "翻译",
    translating: "翻译中...",
    loadMore: "加载更早消息",
    typing: "正在输入...",
    typingMultiple: "正在输入...",
    today: "今天",
    yesterday: "昨天",
    unread: "未读",
    newConversation: "新对话",
    participants: "参与者",
    quoteProposal: "报价方案",
    statusUpdate: "状态更新",
    attachFile: "附加文件",
    accept: "接受",
    counter: "还价",
    connecting: "正在连接聊天...",
    estimatedDays: "预计交付",
    days: "天",
    messageDesigner: "联系设计师",
  },

  pricing: {
    meta: {
      title: "定价 · Caratzon",
      description: "Caratzon 品牌透明定价——采购预工程珠宝设计、生成 AI 营销套件、可持续制造。",
    },
    hero: {
      overline: "品牌专属 · 贸易会员",
      heading: "别再为每个设计支付 $2,500。",
      headingEm: "从 $0 开始。",
      body: "您的会员资格解锁完整目录、AI 驱动的营销工具，以及与独立设计师的直接采购。设计授权另计——您只需为选择生产的设计付费。",
    },
    socialProof: [
      "48+ 预工程设计",
      "来自 6 个国家的设计师",
      "AI 套件 3 分钟内生成",
      "首件即盈利",
    ],
    billing: {
      monthly: "月付",
      annual: "年付",
      savingActive: "节省 ~17%",
      savingPrompt: "年付节省 ~17%",
    },
    tiers: {
      explorer: {
        name: "Discover",
        tagline: "探索可能",
        description: "浏览目录、收藏设计，获得 200 迎新积分生成您的首个 AI 营销套件——免费，无需信用卡。",
        features: [
          "浏览完整目录——每位设计师、每件作品",
          "收藏设计至您的候选清单",
          "200 迎新 Studio Credits（一次性）",
          "生成 2 个 Essentials Kit 亲身体验品质",
          "选择数量——我们处理其余，从 CAD 到交付",
        ],
        cta: "免费开始",
      },
      professional: {
        name: "Source",
        tagline: "直接接触设计师",
        description: "完整采购权限。直接设计师关系。每月 1,500 积分——足够 15 套完整营销套件或 150 张快速目录照片。",
        mostPopular: "最受欢迎",
        features: [
          "Discover 的所有功能，加上：",
          "每月 1,500 Studio Credits",
          "直接从设计师采购——无中间商",
          "通过私信协商授权条款",
          "AI 营销套件：生活照、造型册、社交素材——数分钟完成",
          "Standard + Exclusive 授权层级",
          "按金属、宝石、风格、价格和供应筛选",
        ],
        cta: "开始 Source",
      },
      atelier: {
        name: "Atelier",
        tagline: "您的私人设计工坊",
        description: "通过 Vault 授权实现完整知识产权转让。您的专属制作经理处理从 CAD 到交付的一切。每月 5,000 积分。",
        features: [
          "Source 的所有功能，加上：",
          "Vault 授权——完整 IP + CAD 文件转让",
          "每月 5,000 Studio Credits",
          "专属制作经理——您的单一联络人",
          "优先支持——直线联系、当日回复",
          "抢先接触新设计师",
          "自定采购简报——告诉我们您需要什么，我们来找",
          "多 SKU 订单的批量授权条款",
          "Cara AI——以 AI 辅助设计原创珠宝",
        ],
        cta: "开始 Atelier",
      },
      enterprise: {
        name: "Enterprise",
        tagline: "无限扩展",
        description: "适用于零售连锁店和大型分销商。自定积分额度、API 集成、白手套制作管理和专属客户团队。",
        customLabel: "自定",
        customSublabel: "根据您的规模和需求量身定制",
        features: [
          "Atelier 的所有功能，加上：",
          "自定 Studio Credit 额度——匹配您的目录速度",
          "API 访问——目录、套件和订单管理",
          "跨多家工厂的白手套制作管理",
          "专属客户团队，季度业务回顾",
          "自定 SLA、入职和培训",
          "多席位团队访问，基于角色的权限",
          "协商授权条款和批量折扣",
          "优先制造排队——您的订单优先出货",
        ],
        cta: "联系我们的团队",
      },
    },
    priceDisplay: {
      free: "免费",
      freeSublabel: "无需信用卡",
      perMonth: "/月",
      saveBadge: "（节省 ~17%）",
      orAnnualOption: "或 {amount}/年",
      billedAnnually: "年付 {amount}",
      licensesSeparate: "设计授权另计",
    },
    getStarted: "立即开始",
    studioCredits: {
      overline: "Studio Credits",
      heading: "固定成本，每次操作。无意外。",
      body: "每项 AI 操作——从目录摄影到与 Cara 的设计咨询——都从您的每月配额中扣除固定数量的积分。需要更多？充值包即时可用，永不过期。",
      link: "查看积分费用和充值包 →",
    },
    roi: {
      overline: "数据说话",
      heading: "推出新 SKU 的真正成本。",
      body: "传统采购将利润埋在隐藏成本和数月的交期中。Caratzon 压缩整个流程。",
      traditionalLabel: "传统采购",
      caratzonLabel: "Caratzon",
      rows: [
        { metric: "上市时间", traditional: "4–6 个月", caratzon: "3 周" },
        { metric: "研发与 CAD 建模", traditional: "$800 – $2,500+", caratzon: "$0——预工程" },
        { metric: "实物打样", traditional: "每轮 $500+", caratzon: "$0——AI 渲染预览" },
        { metric: "营销摄影", traditional: "每次活动 $2,000+", caratzon: "约 $7（Studio Credits）" },
        { metric: "盈亏平衡点", traditional: "约售出 50 件", caratzon: "第 1 件" },
      ],
      note: "预工程 CAD 文件。数字孪生打样。AI 驱动摄影。Caratzon 上的每个设计从第一件起即盈利。",
    },
    faq: {
      overline: "常见问题",
      heading: "您需要知道的一切。",
      items: [
        {
          q: "平台费用和设计授权分别包含什么？",
          a: "您的会员资格提供目录访问、AI 驱动营销工具（Studio Credits）和直接采购能力。设计授权另计——您只需为选择生产的设计付费。会员资格是您的工具箱；授权是材料。",
        },
        {
          q: "未使用的 Studio Credits 会怎样？",
          a: "月度积分在每个计费周期结束时过期。这确保定价对所有人公平。如果您经常需要更多，升级计划或购买充值包——充值积分永不过期。",
        },
        {
          q: "可以随时切换计划或取消吗？",
          a: "可以。即时升级，在计费周期结束时降级。无锁定合约，无取消费用。年度计划可取消，未使用月份按比例退款。",
        },
        {
          q: "设计授权具体包含什么？",
          a: "每个授权包含预工程 CAD 文件（直接路由至生产——您无需处理文件）、所选层级的完整商业权利（Standard、Exclusive 或 Vault），以及 Essentials Kit（目录照片、规格、SEO 文案）。带生活摄影的 Caratzon Kit 使用您的 Studio Credits 生成。",
        },
        {
          q: "Vault 授权（IP 转让）如何运作？",
          a: "适用于 Atelier 和 Enterprise 计划。Vault 授予您设计的永久独家所有权——包括原始 CAD 文件。设计师收到一次性买断费。一旦入库，设计将从公开目录中移除。它是您的。",
        },
        {
          q: "我需要自己处理制造吗？",
          a: "不需要。每个生产订单通过我们审核的 EPH 制造网络路由。铸造、镶嵌、质量控制和物流端到端管理。您从仪表板批准里程碑——我们处理其余。",
        },
      ],
    },
    bottomCta: {
      heading: "准备好以不同方式采购了吗？",
      body: "从 Discover 免费开始。准备好时升级——无承诺。",
      button: "浏览目录",
      link: "需要自定计划？联系我们。",
    },
  },

  ai: {
    meta: {
      title: "Cara AI — 珠宝工程智能 · Caratzon",
      description: "Cara 是为工厂车间设计的珠宝工程 AI。收缩补偿、结构分析、物料清单和生产就绪概念——不是幻想渲染。",
      socialDescription: "为真实制造而工程的 AI。收缩、公差、铸造力学、佩戴性——每个概念都是生产就绪的。",
    },
    hero: {
      headingLine1: "不是生成式图像工具。",
      headingLine2: "珠宝工程 AI。",
      ctaDemo: "试用 Cara AI — 即时演示",
      ctaCredits: "查看积分费用",
    },
    pillars: {
      label: "工程约束",
      headingLine1: "每个概念都经过压力测试",
      headingLine2: "在离开屏幕之前。",
    },
    capabilities: {
      label: "能力",
      headingLine1: "从餐巾草图",
      headingLine2: "到生产就绪蓝图。",
    },
    whatYouCanAsk: {
      label: "您可以问什么",
      heading: "对话，不是提示框。",
      groups: [
        {
          title: "设计咨询",
          prompts: [
            "「分析这个草图的可制造性」",
            "「18K 白金的最小壁厚是多少？」",
            "「这个光环镶嵌能承受日常佩戴吗？」",
          ],
        },
        {
          title: "材料科学",
          prompts: [
            "「比较铂金 950 和 18K 在这个戒圈上的表现」",
            "「0.8mm 爪镶应该用什么合金？」",
            "「14K 黄金失蜡铸造的收缩率是多少？」",
          ],
        },
        {
          title: "视觉生成",
          prompts: [
            "「用玫瑰金和密镶戒圈渲染这个概念」",
            "「生成 Art Deco 订婚戒指的情绪板」",
            "「创建这个设计的 360° 旋转视频」",
          ],
        },
        {
          title: "生产规划",
          prompts: [
            "「为这枚戒指生成物料清单」",
            "「估算 18K 配 VS1 钻石的制造成本」",
            "「50 件批量的生产时间表是什么？」",
          ],
        },
      ],
    },
    creditsTeaser: {
      label: "Studio Credits",
      heading: "透明、固定成本的 AI。",
      body: "每个 Cara 操作都有固定积分费用——5 积分一条消息、15 积分一张图像渲染、25 积分一段 360° 视频。无 token 计量，无意外。",
      link: "查看所有积分费用和充值包 →",
    },
    finalCta: {
      heading: "亲自体验。",
      body: "试用即时演示——无需账户。上传草图、提出问题，看 Cara 工程出生产就绪的概念。",
      ctaDemo: "试用 Cara AI — 即时演示",
      ctaPricing: "查看定价",
    },
  },

  designerAi: {
    meta: {
      title: "Cara AI 设计师专用 — Caratzon",
      description: "验证 CAD 可制造性、生成作品集渲染图、360° 视频及造型摄影 — 全由 Cara AI 驱动。专注设计，让 Cara 处理工程细节。",
      socialDescription: "珠宝设计师的 AI 搭档。验证 CAD、生成渲染、打造作品集 — 从第一天起即可量产。",
    },
    hero: {
      overline: "Cara AI · 设计师专用",
      headingLine1: "放胆设计。",
      headingLine2: "Cara 处理工程。",
      body: "Cara 是您的 AI 搭档 — 集珠宝大师与机械工程师于一身。验证 CAD 可制造性、生成专业级渲染图，打造让买家主动联系的作品集。您只需专注创作。",
      ctaDemo: "试用 Cara AI — 即时演示",
      ctaStudio: "打开 Studio",
    },
    pillars: {
      label: "Cara 为您做什么",
      headingLine1: "从 CAD 文件",
      headingLine2: "到可量产的作品集。",
      items: [
        {
          stat: "CAD → 渲染",
          label: "作品集生成",
          body: "上传 .3DM 或 .STL，Cara 即生成专业级产品照、生活风格渲染及 360° 旋转视频 — 过去每件作品需花费数千元的视觉素材。",
        },
        {
          stat: "±0.15mm",
          label: "可制造性检查",
          body: "Cara 根据真实铸造公差分析您的设计 — 壁厚、收缩补偿、爪镶强度、边缘圆角 — 在买家看到之前标记问题。",
        },
        {
          stat: "自动 BOM",
          label: "物料清单",
          body: "即时获得精确的物料清单 — 金属重量、宝石数量、合金成本 — 让您自信定价，买家看到透明的生产估算。",
        },
        {
          stat: "您的故事",
          label: "AI 叙事",
          body: "Cara 为每件作品和系列撰写编辑级叙事。不是千篇一律的文案 — 而是源自您的设计理念、材料和创作意图的故事。",
        },
      ],
    },
    capabilities: {
      label: "设计师功能",
      headingLine1: "从文件到精选",
      headingLine2: "所需一切尽在此处。",
      items: [
        { label: "CAD 验证", detail: "根据 EPH 制造公差进行结构分析 — 壁厚、倒扣、拔模角度" },
        { label: "产品渲染", detail: "多角度、多金属、多宝石配置的专业级产品照" },
        { label: "360° 旋转视频", detail: "动态旋转预览，买家可嵌入演示和提案文件" },
        { label: "造型摄影", detail: "AI 生成的生活风格及模特摄影，匹配您的品牌美学" },
        { label: "系列叙事", detail: "将设计归入系列，Cara 为所有作品撰写统一的编辑故事" },
        { label: "材料智能", detail: "针对 10K–24K 金、925 银、950 铂金的合金专属指导 — 收缩率、硬度、表面处理" },
      ],
    },
    workflow: {
      label: "您与 Cara 的工作流程",
      heading: "上传。验证。发布。",
      steps: [
        {
          title: "上传 CAD",
          body: "将 .3DM、.STL 或 .STEP 文件拖入 Studio。Cara 读取几何结构并立即开始分析。",
        },
        {
          title: "审查与优化",
          body: "Cara 标记可制造性问题、建议修改，并生成完整物料清单。与 Cara 对话迭代 — 询问合金、公差或替代镶嵌方案。",
        },
        {
          title: "生成作品集",
          body: "一键生成产品渲染、生活风格照、360° 视频和编辑故事。您的设计从原始文件变为买家就绪的展示。",
        },
        {
          title: "发布至 Inspire 及目录",
          body: "一步将验证完成、渲染就绪的设计推送至您的 Inspire 创作者页面及贸易目录。买家发现您的作品时，视觉素材和叙事已就位 — 随时可授权。",
        },
      ],
    },
    closing: "Cara 不会取代您的创造力 — 它消除设计与需要看到它的买家之间的一切障碍。无需摄影师、无需文案、无需工厂联络人。只有您的愿景，经过量产验证，精美呈现。",
    creditsTeaser: {
      label: "Studio 积分",
      heading: "固定成本 AI。无隐藏费用。",
      body: "每项 Cara 操作都有透明的积分成本 — 消息 5 积分、渲染 15 积分、360° 视频 25 积分。积分包含在您的方案中，随时可加购。",
      link: "查看积分费用 →",
    },
    finalCta: {
      heading: "您的设计值得被看见。",
      body: "上传第一个 CAD，让 Cara 验证并渲染，发布至 Inspire — 全程不到五分钟。",
      ctaDemo: "试用 Cara AI — 即时演示",
      ctaStudio: "打开 Studio",
    },
  },

  aiCredits: {
    meta: {
      title: "Studio Credits — Caratzon",
      description: "了解 Caratzon 上的 Studio Credits 如何运作——固定成本 AI 操作，用于照片套件、设计咨询等。无按张收费。",
      socialDescription: "固定成本 AI 操作，用于照片套件、设计咨询等。",
    },
    hero: {
      label: "Studio Credits",
      heading: "透明、固定成本的 AI。",
      body: "Caratzon 上每项 AI 驱动的操作都消耗固定数量的 Studio Credits。无按张收费、无 token 计量、无意外。",
    },
    howItWorks: {
      label: "运作方式",
      heading: "获取、使用、充值。",
      steps: [
        { step: "01", title: "获取积分", body: "付费计划包含每月积分配额。Explorer 账户获得 200 迎新积分试用。" },
        { step: "02", title: "用于任何操作", body: "照片套件、造型册、Cara AI 咨询——每项操作都有预先显示的固定积分费用。" },
        { step: "03", title: "需要更多时充值", body: "即时购买积分包。充值积分永不过期——订阅积分每个计费周期重置。" },
      ],
    },
    photoStudio: {
      label: "Photo Studio",
      heading: "生产就绪素材。",
      body: "上传设计，获得目录级摄影、产品线表和营销文案——全部 AI 生成，数分钟完成。",
    },
    caraAi: {
      label: "Cara AI",
      heading: "您的设计工程伙伴。",
      body: "Cara 是一位理解冶金学、宝石镶嵌、结构完整性和制造约束的 AI 珠宝工程师。任何问题都可以问——从材料科学到物料清单估算。",
      note: "发送文字消息时收取 5 积分。图像和视频工具在 AI 调用时收费——运行前您会看到费用。典型的 10 条消息会话加上几次渲染约使用 100–150 积分。",
    },
    monthlyAllowances: {
      label: "每月配额",
      heading: "您的计划包含的积分。",
      tableHeaders: ["计划", "每月积分", "迎新积分", "价格"],
      rows: [
        { plan: "Discover", monthly: "—", welcome: "200", price: "免费" },
        { plan: "Source", monthly: "1,500", welcome: "—", price: "$149/月" },
        { plan: "Atelier", monthly: "5,000", welcome: "—", price: "$399/月" },
        { plan: "Enterprise", monthly: "自定", welcome: "—", price: "自定" },
      ],
      note: "订阅积分每个计费周期重置——未使用的积分不会滚存。充值积分永不过期。",
    },
    topUpPacks: {
      label: "充值包",
      heading: "额外购买，永久保留。",
      body: "推出大型系列？即时购买积分——永不过期。",
      bestValue: "最超值",
      creditsLabel: "积分",
      perCredit: "¢ 每积分",
      buyPrefix: "购买",
      buySuffix: "积分",
      note: "订阅始终是最划算的——订阅积分的每积分成本低于充值包。",
      compareLink: "比较计划",
    },
    faq: {
      label: "常见问题",
      heading: "积分，详解。",
      items: [
        { q: "与 Cara 对话中途积分用完怎么办？", a: "发送前会检查文字消息——您会看到充值提示。图像和视频工具在生成前检查，AI 会在运行昂贵操作前告知您是否需要更多积分。" },
        { q: "未使用的订阅积分会滚存吗？", a: "不会。订阅积分在每个计费周期开始时重置。如果您经常需要更多，考虑升级计划或购买充值包——充值积分永不过期。" },
        { q: "单条 Cara 消息费用会超过 5 积分吗？", a: "会。基本消息费用 5 积分，但如果 Cara 在回复中生成图像（每张 15 积分）或视频（每段 25 积分），这些会逐步收费。典型的设计咨询加 2–3 次渲染约 50–70 积分。" },
        { q: "管理员会被收取积分吗？", a: "不会。管理员账户免于积分收费，用于内部测试和运营。" },
        { q: "Essentials Kit 和 Caratzon Kit 有什么区别？", a: "Essentials Kit（10 积分）生成目录级照片、规格和 SEO 文案。Caratzon Kit（100 积分）包含 Essentials 的所有内容，加上带生活摄影、编辑图像和社交素材的完整造型册。" },
      ],
    },
    actions: {
      photoStudio: [
        { action: "Essentials Kit", detail: "目录照片、规格和 SEO 文案" },
        { action: "Caratzon Kit", detail: "完整照片工作室——生活摄影、产品线表和社交素材" },
        { action: "单张照片重新生成", detail: "重新生成一张不满意的照片" },
        { action: "造型册 PDF", detail: "品牌批发产品线表" },
      ],
      caraAi: [
        { action: "消息", detail: "草图分析、问答、材料科学、结构审查或设计咨询" },
        { action: "草图", detail: "根据文字描述快速生成概念草图" },
        { action: "图像渲染", detail: "忠实的草图到概念渲染、情绪板、目录照片或设计调整" },
        { action: "造型册图像", detail: "用于演示文稿的编辑造型册图像" },
        { action: "360° 视频", detail: "从每个角度展示您设计的旋转视频" },
      ],
    },
  },

  academy: {
    meta: {
      title: "学院 — Caratzon",
      description: "为设计师及微品牌提供珠宝制造、品牌建设及行业趋势的专业指南。",
    },
    hero: {
      title: "Caratzon 学院",
      subtitle: "为珠宝设计师及新兴品牌提供专业知识 — 从 CAD 到商业。",
    },
    categories: {
      all: "全部",
      manufacturing: "制造",
      business: "商业",
      trends: "趋势",
      wholesale: "批发",
      brand: "品牌",
      tech: "科技",
      operations: "运营",
    },
    readingTime: "分钟阅读",
    featured: "精选",
    relatedArticles: "相关文章",
    backToAcademy: "← 返回学院",
    cta: {
      title: "准备好将设计变为现实？",
      description: "Caratzon 将独立设计师与认证制造商连接，实现无缝生产。",
      button: "开始使用 Caratzon →",
    },
    rss: "RSS 订阅",
    noArticles: "暂无文章，敬请期待！",
  },

  newsroom: {
    meta: {
      title: "Newsroom — Caratzon",
      description:
        "Latest news, press releases, and updates from Caratzon. Company announcements, product launches, partnerships, and industry insights.",
    },
    hero: {
      issueLabel: "Newsroom",
      title: "Latest from Caratzon",
      subtitle: "Company news, press releases, product updates, and industry insights.",
    },
    categories: {
      all: "All",
      company: "Company",
      product: "Product",
      partnership: "Partnership",
      industry: "Industry",
      press_release: "Press Release",
    },
    readingTime: "min read",
    featured: "Featured",
    relatedArticles: "Related Articles",
    backToNewsroom: "← Back to Newsroom",
    cta: {
      title: "Ready to bring your designs to life?",
      description:
        "Caratzon connects independent designers with certified manufacturers for seamless production.",
      button: "Start on Caratzon →",
    },
    noArticles: "No articles yet. Check back soon!",
    pressAssets: {
      meta: {
        title: "Press Assets — Caratzon Newsroom",
        description:
          "Brand logos, guidelines, and media resources for press and partners. Download Caratzon brand assets for editorial use.",
      },
      hero: {
        issueLabel: "Press Assets",
        title: "Press Assets",
        subtitle:
          "Brand resources for press, partners, and editorial use. Download logos and guidelines below.",
      },
      logos: {
        heading: "Brand Logos",
        primary: "Primary logo (light)",
        dark: "Primary logo (dark)",
        icon: "Icon only",
        stacked: "Stacked",
      },
      guidelines: {
        heading: "Brand Guidelines",
        colorPalette: "Color Palette",
        colorNotes:
          "Primary brand accent: Teal Sapphire (#005F6B). Deep India ink for text. Warm cream vellum for backgrounds. Gold leaf reserved for decorative use only.",
        typography: "Typography",
        typographyNotes:
          "Display: Cormorant Garamond, Cormorant SC. Body: Inter. Use display fonts for headlines and editorial accents; Inter for UI and body copy.",
      },
      contact: {
        heading: "Press Contact",
        description: "For media inquiries, press kits, and interview requests:",
        contactLink: "General inquiries →",
      },
    },
  },

  contentKit: {
    nav: "Caratzon Kit",
    meta: {
      title: "Caratzon Kit — Caratzon",
      description: "为您的珠宝设计创建完整的 Caratzon Kit — 专业模特摄影、造型手册、目录图片、社交媒体文案和编辑故事。",
    },
    list: {
      title: "您的 Caratzon Kit",
      subtitle: "从您的设计作品生成营销就绪的模特摄影、视觉素材、文案和造型手册。",
      createNew: "新建 Caratzon Kit",
      empty: "尚无 Caratzon Kit。立即创建您的第一个。",
      status: {
        draft: "草稿",
        generating: "生成中",
        ready: "就绪",
        failed: "失败",
      },
    },
    wizard: {
      step1: "选择素材来源",
      step2: "生成视觉素材",
      step3: "生成文案",
      step4: "创建造型手册",
      step5: "发布与分享",
      source: {
        title: "选择您的设计来源",
        fromCatalog: "从目录选取",
        fromCatalogDesc: "选择您已授权的市场设计作品。",
        uploadNew: "上传图片",
        uploadNewDesc: "上传您自己的珠宝照片。",
        titleLabel: "作品名称",
        descriptionLabel: "描述",
        next: "生成视觉素材",
      },
      visuals: {
        title: "已生成的视觉素材",
        subtitle: "AI 增强的产品照片和生活风格造型图。",
        generating: "正在生成您的视觉素材……",
        regenerate: "重新生成",
        acceptAll: "接受并继续",
        catalogShot: "产品照片",
        lookbookShot: "生活风格",
      },
      copy: {
        title: "营销文案",
        subtitle: "AI 生成的产品描述和社交媒体文案。",
        generating: "正在撰写您的文案……",
        productDescription: "产品描述",
        brandStory: "品牌故事",
        socialCaptions: "社交媒体文案",
        regenerate: "重新生成文案",
        next: "创建造型手册",
      },
      lookbook: {
        title: "造型手册预览",
        subtitle: "您的 AI 组装造型手册已准备好下载。",
        generating: "正在组装您的造型手册……",
        template: "模板风格",
        regenerate: "以不同风格重新生成",
        templates: {
          minimal: "极简",
          editorial: "编辑风",
          bold: "大胆",
          organic: "自然",
        },
        next: "发布与分享",
      },
      publish: {
        title: "发布与分享",
        subtitle: "下载您的 Caratzon Kit 或发布到探索发现。",
        download: "下载",
        downloadAll: "下载完整 Caratzon Kit",
        downloadImages: "下载图片 (ZIP)",
        downloadCopy: "下载文案 (TXT)",
        downloadPdf: "下载造型手册 (PDF)",
        publish: "发布到探索发现",
        publishDesc: "在 Caratzon 上公开您的探索发现页面。",
        slugLabel: "探索发现网址",
        categoryLabel: "类别",
        materialsLabel: "材质",
        keywordsLabel: "风格关键词",
        heroLabel: "主图",
        published: "已发布！",
        viewDiscovery: "查看探索发现页面",
      },
    },
    upsell: {
      title: "Studio Credits 已用完",
      body: "升级至 Source 每月获得 1,500 Studio Credits——足够生成 15 个 Caratzon Kit。或即时购买充值包。",
      cta: "查看方案",
    },
  },

  concierge: {
    title: "Caratzon 礼宾服务",
    subtitle: "您的 B2B 珠宝采购助手",
    welcome: "欢迎！您可以询问我们的设计、授权方案、制造流程，或任何关于 Caratzon 的问题。",
    inputPlaceholder: "询问设计、授权、定价...",
    disclaimer: "AI 驱动，回复可能不完全准确。",
    quickActions: [
      "授权如何运作？",
      "我是设计师——如何加入？",
      "有哪些定价方案？",
      "我想联系真人客服",
    ],
    leadForm: {
      title: "与我们的团队联系",
      description: "请分享您的信息，Caratzon 团队将在 24 小时内跟进。",
      name: "您的姓名",
      email: "商务邮箱",
      company: "公司名称（选填）",
      message: "请简要描述您需要的帮助...",
      submit: "联系团队",
      successTitle: "已连接",
      success: "Caratzon 团队将在 24 小时内与您联系。您可以继续在此聊天。",
    },
    handoffConfirm: {
      title: "已请求转接",
      description: "我们已将您的请求详情通知 Caratzon 团队。团队成员将尽快与您联系。您可以继续在此聊天，或直接发送邮件至 trade@caratzon.com。",
    },
  },

  inspire: {
    meta: {
      title: "灵感 — Caratzon",
      description: "探索来自世界各地设计师和品牌的精美珠宝设计。",
    },
    explore: {
      title: "灵感",
      subtitle: "探索来自世界各地创作者的珠宝设计。",
      allCategories: "全部",
      noResults: "此类别中未找到相关作品。",
    },
    profile: {
      pieces: "作品",
      totalViews: "总浏览量",
    },
    detail: {
      by: "作者",
      views: "浏览",
      materials: "材质",
      share: "分享",
      viewProfile: "查看个人资料",
      cta: {
        title: "创建您自己的灵感页面",
        body: "加入设计师行列，通过 AI 生成的造型手册、编辑故事和专属个人主页，在您自己的 Studio 中展示您的作品。",
        button: "开始创作",
      },
    },
    saved: {
      title: "已收藏作品",
      empty: "暂无收藏作品。",
      emptySubtitle: "浏览灵感页面，发现您的心仪之作。",
      backToInspire: "返回灵感",
    },
    creatorOnboarding: {
      meta: {
        title: "加入 Inspire 成为创作者 · Caratzon",
        description: "向我们介绍您的工艺、故事与愿景——我们将把您展示给全世界。",
      },
      header: "Inspire · 创作者入驻",
      stepOf: "第 {step} 步，共 {total} 步",
      back: "← 返回",
      continue: "继续 →",
      steps: {
        profile: "个人资料",
        styleTools: "风格与工具",
        creativeDna: "创意基因",
        philosophy: "设计理念",
        innerWorld: "内心世界",
        production: "生产准备",
        review: "审核确认",
      },
      profile: {
        title: "您的设计师档案",
        subtitle: "买家和采购经理将在平台上这样看到您。",
        firstName: "名 *",
        lastName: "姓 *",
        studioName: "工作室 / 品牌名称",
        studioPlaceholder: "例如 Studio Noir、Aria Atelier",
        location: "所在地 / 城市",
        locationPlaceholder: "例如 巴黎、法国",
        photo: "头像照片",
        photoOptional: "（选填 — AI 增强）",
        photoHint: "上传头像或生活照。我们的 AI 将为其添加温暖影棚灯光和简洁背景。",
        photoEnhancing: "正在用 AI 增强您的照片…",
        photoSaved: "照片已增强并保存 ✓",
        photoChange: "更换",
        photoUpload: "上传",
      },
      style: {
        title: "您的审美与工具",
        subtitle: "我们据此将您的作品与合适的买家受众匹配。",
        aestheticLabel: "您如何描述您的设计审美？ *",
        aestheticHint: "可多选",
        designStyleLabels: {
          "Minimalist": "极简",
          "Vintage-inspired": "复古风格",
          "Bridal/Engagement": "婚嫁 / 订婚",
          "Men's": "男士",
          "Bold/Chunky": "大胆 / 厚实",
          "Trend-driven Fashion": "潮流时尚",
          "Everyday Fine": "日常精品",
          "Maximalist": "极繁",
        } as Record<string, string>,
        cadLabel: "您主要使用哪些 CAD 软件？ *",
        cadHint: "可多选",
        formatsLabel: "您能提供哪些文件格式？",
        formatsHint: "可多选",
      },
      creative: {
        title: "您的创意基因",
        subtitle: "帮助我们了解您工艺的根源。这些回答将塑造 AI 如何向买家讲述您的故事。",
        originLabel: "您是如何成为珠宝设计师的？ *",
        originHint: "您的起源故事——是什么将您吸引到这门技艺？童年记忆、导师、转折点？",
        originPlaceholder: "我从小看着祖母在斋浦尔的工作室里将米珠穿到丝线上。光线掠过每颗珠子的方式对我来说如同魔法…",
        materialsLabel: "您对哪些材料最有共鸣？",
        materialsHint: "选择所有有共鸣的",
        signatureMaterialLabels: {
          "Gold (yellow, rose, white)": "黄金（黄金、玫瑰金、白金）",
          "Platinum": "铂金",
          "Silver / Sterling": "银 / 纯银",
          "Titanium": "钛",
          "Enamel": "珐琅",
          "Precious gemstones": "珍贵宝石",
          "Semi-precious stones": "半宝石",
          "Pearls": "珍珠",
          "Diamonds": "钻石",
          "Wood / organic materials": "木材 / 天然材料",
          "Recycled metals": "再生金属",
          "Lab-grown stones": "实验室培育宝石",
          "Mixed media": "混合媒材",
        } as Record<string, string>,
        ritualsLabel: "描述您的创作仪式",
        ritualsHint: "您的流程是怎样的？先手绘草图、直接上 CAD、还是用蜡雕？您在哪里工作？",
        ritualsPlaceholder: "我总是从纹理纸上的水彩草图开始。我需要先感受重量与流动，才会触碰屏幕…",
        culturalLabel: "哪些文化或历史影响塑造了您的作品？",
        culturalHint: "传统、地域、时代、艺术运动——任何滋养您视觉语言的事物。",
        culturalPlaceholder: "装饰艺术几何、莫卧儿花卉纹样、日式侘寂的不完美…",
      },
      philosophy: {
        title: "您的设计理念",
        subtitle: "这些问题揭示您如何思考您的技艺——那些让您的作品独具一格的张力、信念与选择。",
        oneWordLabel: "如果用一个词描述您的设计理念，会是什么？ *",
        oneWordPlaceholder: "例如 张力、敬畏、叛逆、流动",
        feelingLabel: "当有人佩戴您的珠宝时，他们应该感受到什么？ *",
        feelingHint: "不是他们应该看起来怎样——而是这件作品应唤起怎样的情感状态？",
        feelingPlaceholder: "仿佛他们怀揣着一个秘密——珍贵且完全属于自己。一种无需张扬的从容自信。",
        tensionLabel: "什么创作张力定义了您的作品？",
        tensionHint: "每位设计师都在权衡取舍。装饰与克制？传统与颠覆？完美与粗粝？",
        tensionPlaceholder: "我总在精准与不完美之间拉扯。我希望每根线条都经过深思，但我也为金属留出惊喜的空间…",
        opinionLabel: "您对珠宝设计有什么不太主流的看法？",
        opinionHint: "您相信但业内大多数人可能不同意的事。",
        opinionPlaceholder: "我认为对称被高估了。最美的作品往往带有刻意的非对称，让它们充满生机…",
      },
      innerWorld: {
        title: "您的内心世界",
        subtitle: "这些更深层的问题帮助我们的 AI 了解工作台之外的您——让您的设计师故事真实如您本人。",
        inspirationLabel: "珠宝之外，什么启发您的设计？ *",
        inspirationHint: "建筑、音乐、自然、美食、电影、数学、一座城市、一种感觉——任何事物。",
        inspirationPlaceholder: "粗野主义混凝土捕捉午后光线的方式。鹦鹉螺壳中的数学螺旋。日式枯山水庭园的寂静…",
        emotionalLabel: "设计满足了您怎样的情感需求？",
        emotionalHint: "您为何持续创作？没有它，您的生活会缺少什么？",
        emotionalPlaceholder: "那是我唯一能让思绪安静下来的时刻。当我沉浸于设计中，喧嚣停止，只剩下作品与我…",
        legacyLabel: "20 年后，您希望您的作品集对您说什么？",
        legacyHint: "您的传承愿景——什么线索应贯穿您创造的一切？",
        legacyPlaceholder: "我制作的不只是人们佩戴的作品，而是他们会珍藏的物件。成为某人故事的一部分，代代相传——不是因为价值，而是因为意义…",
        metaphorLabel: "如果您的设计实践是一个地方，它会是什么样子？",
        metaphorHint: "您创意空间的隐喻——真实或想象。",
        metaphorPlaceholder: "悬崖边的一座玻璃工作室。精密的工具，开阔的视野。室内井然有序；室外野性未驯…",
      },
      production: {
        title: "生产就绪度",
        subtitle: "制造商需要针对实体生产优化的 CAD 文件——镶爪厚度、金属重量、收缩公差。",
        cadOptimisedLabel: "您的 CAD 文件是否已完全针对实体制造优化？",
        optionYes: "是 — 我的文件已完全针对制造优化",
        optionMostly: "基本是 — 可能需要小幅调整",
        optionNo: "否 — 我仅为渲染/可视化设计",
        optionHelp: "我需要帮助优化我的文件",
        portfolioLabel: "作品集 / 网站",
        portfolioPlaceholder: "https://yourportfolio.com",
        socialLabel: "社交媒体",
        socialOptional: "（选填 — 将显示在您的 Inspire 页面）",
        instagramPlaceholder: "@yourstudio 或 https://instagram.com/yourstudio",
        pinterestPlaceholder: "@yourstudio 或 https://pinterest.com/yourstudio",
        tiktokPlaceholder: "@yourstudio 或 https://tiktok.com/@yourstudio",
        sampleUploadsTitle: "样稿上传",
        sampleUploadsBody: "完成档案后，您可直接从 Studio 仪表板上传 CAD 渲染图和成品照片。",
      },
      review: {
        title: "审核您的档案",
        subtitle: "一切无误？审核通过后，您可从 Studio 设置中更新这些内容。",
        aiEnhanced: "AI 增强肖像",
        labels: {
          name: "姓名",
          studio: "工作室",
          location: "所在地",
          aesthetic: "审美",
          cadSoftware: "CAD 软件",
          fileFormats: "文件格式",
          productionReady: "生产就绪",
          portfolio: "作品集",
          instagram: "Instagram",
          pinterest: "Pinterest",
          tiktok: "TikTok",
        },
        creativeProfile: "您的创意档案",
        creativeLabels: {
          originStory: "起源故事",
          materials: "材料",
          philosophy: "理念",
          wearerFeels: "佩戴者感受",
          inspiration: "灵感",
          legacy: "传承",
        },
        storyGeneration: {
          title: "生成您的设计师故事",
          subtitle: "我们的 AI 将根据您的问卷回答撰写引人入胜的叙事——准备发布到您的 Inspire 页面。",
          button: "生成我的故事",
          loading: "正在撰写您的叙事…",
          error: "故事生成失败",
          tryAgain: "重试",
          refineLater: "审核通过后，您可从 Studio 仪表板润色此故事。",
        },
        terms: {
          prefix: "我确认以上信息准确，并同意 Caratzon 的",
          termsLink: "设计师服务条款",
          and: "及",
          privacyLink: "隐私政策",
        },
        submit: "提交申请 →",
        submitting: "提交中…",
      },
      errors: {
        nameRequired: "请输入您的姓名。",
        agreeRequired: "您必须同意设计师条款才能继续。",
        submissionFailed: "提交申请时出错，请重试。",
      },
      pending: {
        meta: {
          title: "申请审核中 · Caratzon",
          description: "您的设计师申请正在由我们的团队审核。",
        },
        overline: "内测阶段",
        thankYou: "感谢您，{name}",
        thankYouGeneric: "感谢您",
        submitted: "您的申请已成功提交。Caratzon 目前处于",
        privateBeta: "内测阶段",
        submittedSuffix: "，我们的团队会亲自审核每一位设计师的申请。",
        emailNotice: "您的账户获批后，我们将通过邮件通知您。通常需要 1–2 个工作日。",
        backToHome: "返回首页",
        exploreAcademy: "探索学院 →",
        rejected: {
          overline: "申请更新",
          heading: "我们目前无法批准您的申请",
          body: "感谢您对 Caratzon 的兴趣。很遗憾，我们目前无法批准您的申请。如您认为有误或希望提供更多信息，请联系我们的团队。",
          feedbackLabel: "我们团队的反馈",
          contactUs: "联系我们",
          reapply: "重新申请",
          reapplying: "提交中…",
        },
      },
    },
  },

  caraChat: {
    empty: {
      title: "认识 Cara",
      description: "您的 AI 设计助手 — 集珠宝大师与机械工程师于一身。描述您的构想、上传草图，或拖放灵感图片开始创作。",
      sketchToConcept: "草图 → 概念",
      photoToDesign: "照片 → 设计",
      ideaToRender: "构想 → 渲染",
    },
    placeholder: {
      initial: "描述您的构想、上传草图，或拖放灵感图片…",
      direction: "告诉 Cara 设计方向 — 材质、风格、年代…",
      adjust: "要求 Cara 调整设计，或进行结构分析…",
      finalize: "准备定稿？让 Cara 生成目录渲染图和材料清单。",
    },
    dragOverlay: "拖放草图或参考图片",
    scrollPill: "↓ 新消息",
    sketchFallback: "这是我的草图/参考图片，请分析。",
    error: "出了点问题，请重试。",
    regenerate: "重新生成",
    suggestions: {
      custom: "其他…",
      customPlaceholder: "输入您的答案…",
      send: "发送",
    },
    editMessage: "编辑消息",
    editSend: "发送",
    editCancel: "取消",
    download: "下载",
    copyMessage: "复制消息",
    justNow: "刚刚",
    minutesAgo: "{n}分钟前",
    toolLabels: {
      generate_mood_board: "情绪板",
      generate_concept_sketch: "概念草图",
      generate_design_render: "设计渲染",
      adjust_design: "调整渲染",
      generate_catalog_render: "目录渲染",
      render_from_sketch: "草图概念",
      analyze_sketch: "草图分析",
      analyze_inspiration: "灵感分析",
      reference_lookup: "参考查询",
      structural_analysis: "结构分析",
      calculate_bom: "材料清单",
      material_recommendation: "材质分析",
      generate_turntable_video: "旋转视频",
      generate_lookbook_image: "造型照",
      present_design_specs: "设计规格",
      finalize_design: "设计定稿",
      share_to_gallery: "分享至画廊",
    },
    toolLoading: {
      rendering: "渲染中…",
      sketchingConcept: "绘制概念中…",
      analyzingSketch: "分析草图中…",
      analyzingInspiration: "分析灵感中…",
      lookingUpReference: "查询参考资料中…",
      generatingVideo: "生成视频中 — 最多需要一分钟…",
      stylingLookbook: "制作造型照中…",
      structuralAnalysis: "执行可制造性模拟中…",
      materialCheck: "检查材质兼容性中…",
      calculatingBom: "计算材料清单中…",
      sharingToGallery: "分享至画廊中…",
      preparingSpecs: "准备规格中…",
      finalizingDesign: "定稿设计中…",
      processing: "处理中…",
    },
    toolCards: {
      moodBoard: "情绪板",
      conceptSketch: "概念草图",
      refinedSketch: "精修草图",
      turntablePreview: "旋转预览",
      sketchAnalysis: "草图分析",
      inspirationAnalysis: "灵感分析",
      structuralAnalysis: "结构分析",
      billOfMaterials: "材料清单",
      materialAnalysis: "材质分析",
      designFinalized: "设计已定稿",
      sharedToGallery: "已分享至画廊",
      errorFallback: "出了点问题。",
      designRender: "设计渲染",
      updatedRender: "更新渲染",
      catalogRender: "目录渲染",
      conceptFromSketch: "草图概念",
      lookbookLabel: "造型照",
      saveToStudio: "保存至 Studio",
      savedOpenStudio: "已保存 — 打开 Studio",
      submitBrief: "提交设计简报",
      briefSubmitted: "简报已提交 — 查看订单",
      designTitlePlaceholder: "设计标题…",
      saving: "保存中…",
      save: "保存",
      cancel: "取消",
      structural: {
        manufacturabilityReport: "可制造性报告",
        areasAnalyzed: "已分析 {n} 个区域",
        areasAnalyzedPlural: "已分析 {n} 个区域",
        issuesFound: "发现问题",
        warnings: "警告",
        allClear: "全部通过",
        pass: "通过",
        warning: "警告",
        warningPlural: "警告",
        critical: "严重",
        recommendationLabel: "建议：",
        addressCritical: "请在铸造前解决严重问题。",
        reviewWarnings: "请检查上述警告 — 设计可制造，但需作调整。",
      },
      bom: {
        costBreakdown: "成本明细",
        lineItems: "{n} 个项目",
        lineItemsPlural: "{n} 个项目",
        item: "项目",
        qty: "数量",
        estCost: "预估成本",
        laborSetting: "工费及镶嵌",
        totalEstimate: "预估总计",
      },
      material: {
        compatibilityCheck: "兼容性检查",
        compatible: "兼容",
        concerns: "需注意",
        concernsLabel: "需注意事项",
        recommendationsLabel: "建议",
        allCompatible: "所有材质均可用于生产。",
      },
      sketch: {
        sketchInterpretation: "草图解读",
        needsInput: "需要确认",
        stones: "宝石",
        filigree: "花丝工艺",
        engraving: "雕刻",
        designNotes: "设计备注",
        needsClarification: "待确认事项",
      },
      inspiration: {
        inspirationBreakdown: "灵感解析",
        colorPalette: "色彩",
        motifs: "图案元素",
        textures: "质感",
        suggestedFinishes: "建议表面处理",
        suggestedForms: "建议珠宝形态",
      },
      designSpecs: {
        weight: "重量",
        stones: "宝石",
        stoneSingular: "宝石",
        finish: "表面处理",
        stonesLabel: "宝石",
        dimensions: "尺寸",
        manufacturable: "可制造",
        manufacturabilityConcerns: "制造性疑虑",
      },
      finalize: {
        productionReady: "可量产",
        metal: "金属",
        stones: "宝石",
        stoneSingular: "宝石",
        estRetail: "预估零售价",
        cadHandoff: "可进行 CAD 交付、铸造或报价",
      },
      gallery: {
        nowInGallery: "已加入画廊",
        storyGenerating: "设计故事生成中 — 请至画廊页面查看。",
      },
      reference: {
        title: "参考数据",
        casting: "铸造规格",
        metals: "金属特性",
        stones: "宝石耐久性",
        settings: "镶嵌兼容性",
      },
    },
    starters: [
      { label: "单钻戒指", text: "设计一枚18K玫瑰金镶嵌1克拉椭圆形钻石的现代单钻订婚戒指" },
      { label: "装饰艺术鸡尾酒戒指", text: "创作一枚以装饰艺术几何风格为灵感、镶嵌祖母绿和缟玛瑙的大胆鸡尾酒戒指" },
      { label: "网球手链", text: "设计一条铂金镶嵌蓝宝石和钻石交替排列的极简网球手链" },
    ],
    buyerOverrides: {
      empty: {
        title: "用Cara设计",
        description: "描述您想要的珠宝——风格、材质、场合——Cara将以可量产的渲染图呈现您的愿景。",
      },
      placeholder: {
        initial: "描述您想要的珠宝——风格、材质、场合……",
        direction: "告诉Cara更多偏好——材质、预算、数量……",
        adjust: "让Cara调整设计，或探索不同的变化……",
        finalize: "对设计满意？提交为量产设计简报。",
      },
      starters: [
        { label: "定制订婚戒指", text: "我想要一枚定制订婚戒指——椭圆形钻石、现代镶嵌、玫瑰金" },
        { label: "品牌系列单品", text: "我需要一款品牌标志性吊坠——极简风格、14K金、零售价200美元以下" },
        { label: "婚戒套装", text: "设计一对铂金情侣婚戒，带有精致细节" },
      ],
    },
  },

  demo: {
    meta: {
      title: "Cara AI 演示 · Caratzon",
      description: "试用 Cara——为工厂和人手而设计的珠宝工程 AI。收缩率、公差、铸造力学、佩戴舒适度——每个概念均可直接投产。现场演示。",
    },
    splash: {
      eyebrow: "珠宝工程 AI",
      heading: "认识 Cara",
      subheading: "工程 AI，设计工厂能制造、顾客想佩戴的珠宝——从第一张草图开始。",
      cta: "开始设计",
      enterHint: "按 {key} 开始",
      promptDivider: "或试试以下提示",
      signIn: "登录",
      noAccount: "无需账户",
      notSaved: "对话不会被保存",
      fullAccess: "完整平台访问 →",
      namePlaceholder: "您的名字（显示在展览中）",
      nameHint: "用于标注您的创作",
    },
    prompts: [
      { label: "订婚戒指", text: "设计一枚现代单石订婚戒指，配 1 克拉椭圆形钻石，18K 玫瑰金" },
      { label: "Art Deco 鸡尾酒戒指", text: "创作一枚大胆的 Art Deco 风格鸡尾酒戒指，配祖母绿和玛瑙" },
      { label: "网球手链", text: "设计一条极简网球手链，蓝宝石与钻石交替排列，铂金材质" },
      { label: "雕塑手镯", text: "我想要一个有机流线造型的雕塑金手镯，不镶嵌宝石，纯粹金属工艺" },
    ],
    capabilities: [
      { label: "草图到生产蓝图", desc: "上传手绘草图——Cara 为工厂进行工程设计" },
      { label: "铸造与收缩分析", desc: "金属特定收缩补偿、壁厚验证" },
      { label: "宝石公差映射", desc: "爪位、座深和腰围间隙——工程设计" },
      { label: "佩戴感与舒适度", desc: "戒圈轮廓、重量平衡、边缘半径——为全天佩戴而设计" },
    ],
    header: {
      brandLabel: "Cara AI",
      tabs: { create: "创作", gallery: "展览" },
      back: "← 返回",
      fullAccess: "获取完整访问",
    },
    gallery: {
      loading: "加载展览中…",
      emptyTitle: "暂无设计",
      emptyBody: "成为第一个创作者。演示期间生成的设计将在此展示给所有人。",
      emptyAction: "创作第一个设计",
      sectionTitle: "在此活动中创作",
      countSingular: "{count} 个设计由演示访客生成",
      countPlural: "{count} 个设计由演示访客生成",
      createYours: "创作您的",
      createdWith: "由 Cara AI 创作",
      generating: "正在生成故事…",
      viewStory: "查看故事",
      toolLabels: {
        render: "AI 渲染",
        mood_board: "灵感板",
        catalog_render: "目录渲染",
      },
      fallbackTool: "渲染",
      timeAgo: {
        justNow: "刚刚",
        minutes: "{n}分钟前",
        hours: "{n}小时前",
        days: "{n}天前",
      },
    },
    story: {
      backToGallery: "← 返回展览",
      fromSketch: "手绘稿",
      theSketch: "草图",
      sketchCaption: "{name} 的原创草图",
      theDetails: "设计细节",
      detailType: "类型",
      detailMetal: "金属",
      detailStyle: "风格",
      detailStones: "宝石",
      detailFinish: "表面处理",
      detailWeight: "重量",
      detailPrice: "预估价格",
      structuralAnalysis: "结构分析",
      theStory: "故事",
      showcase: "展示",
      designJourney: "设计历程",
      theConversation: "设计对话",
      moreMessages: "对话中还有 {n} 条更多消息",
      createdBy: "创作者",
      createdWith: "在{event}使用 Cara AI 创作",
      eventName: "现场演示",
      tryIt: "亲自试用 Cara →",
      artifactLabels: {
        render: "设计渲染",
        catalog_render: "目录渲染",
        concept_sketch: "概念草图",
        mood_board: "情绪板",
        structural_analysis: "结构分析",
        material_recommendation: "材料分析",
        bom: "物料清单",
        sketch_analysis: "草图分析",
        lookbook: "造型照",
        video: "旋转视频",
        inspiration: "灵感分析",
        design_specs: "设计规格",
        finalize_design: "最终设计",
        gallery_share: "画廊分享",
      },
    },
    brands: {
      splash: {
        eyebrow: "品牌设计智能",
        subheading: "描述您的愿景。即时渲染。直接投产。",
        cta: "开始探索",
        namePlaceholder: "您的姓名或品牌",
        nameHint: "为您提供个性化体验",
        fullAccess: "开设贸易账户 →",
      },
      prompts: [
        { label: "定制网球手链", text: "为我的春季系列将这条网球手链定制为玫瑰金" },
        { label: "品牌标志吊坠", text: "用我们品牌的几何图案创作一款标志性吊坠 — 极简风格、14K金" },
        { label: "婚戒选择", text: "展示三个价位的极简婚戒套装选项" },
        { label: "草图到量产", text: "我有一个手镯草图 — 能做成可量产的设计吗？" },
      ],
      capabilities: [
        { label: "定制预览", desc: "以照片级渲染查看您的设计愿景" },
        { label: "材质与表面处理", desc: "并排比较金属、宝石和表面处理" },
        { label: "样品报价", desc: "原型制作和小批量生产的即时估价" },
        { label: "生产时间线", desc: "从概念到交付 — 查看完整制造路径" },
      ],
      header: {
        fullAccess: "开设贸易账户",
      },
    },
  },

  // ─── Production Dashboard ─────────────────────────────────────────────────
  productionDashboard: {
    title: "生产仪表板",
    tabs: {
      portfolio: "总览",
      board: "看板",
    },
    zoom: "缩放",
    day: "日",
    week: "周",
    month: "月",
    search: "搜索...",
    searchPlaceholder: "搜索计划、设计、制造商...",
    keyboardShortcuts: "键盘快捷键",
    groupBy: "分组方式",
    status: "状态",
    phase: "阶段",
    dragDisabledInPhase: "阶段视图中无法拖拽",
    backToPortfolio: "总览",
    subOrders: "子订单",
    unassigned: "未分配",
    noItems: "暂无项目",
    densityCompact: "紧凑视图",
    densityComfortable: "舒适视图",

    empty: {
      portfolioTitle: "暂无进行中的生产",
      portfolioDescription: "在生产规划器中创建的计划获批后将显示于此。",
      portfolioLink: "打开生产规划器",
      boardTitle: "暂无子订单",
      boardDescription: "没有符合筛选条件的子订单。",
      boardLink: "查看总览",
      planTitle: "暂无子订单",
      planDescription: "此计划尚未创建子订单。",
      planLink: "打开生产规划器",
    },

    filters: {
      allStatuses: "所有状态",
      allDesigners: "所有设计师",
      allBuyers: "所有买家",
    },

    command: {
      noResults: "未找到结果。",
      productionPlans: "生产计划",
      quickActions: "快速操作",
      goToPortfolio: "前往总览",
      goToBoard: "前往看板",
      navigate: "导航",
      open: "打开",
      close: "关闭",
    },

    kanban: {
      blockedAndCancelled: "受阻及已取消",
      columns: {
        PENDING: "待处理",
        QUOTED: "已报价",
        ASSIGNED: "已分配",
        IN_PROGRESS: "进行中",
        QA: "质量控制",
        COMPLETED: "已完成",
        BLOCKED: "受阻",
        CANCELLED: "已取消",
      },
    },

    gantt: {
      today: "今天",
      criticalPath: "关键路径",
      duration: "工期",
      days: "天",
      manufacturer: "制造商",
      dependsOn: "依赖于",
    },

    detail: {
      status: "状态",
      manufacturer: "制造商",
      duration: "工期",
      dependencies: "依赖项目",
    },

    hover: {
      duration: "工期",
      manufacturer: "制造商",
    },
  },

  // ─── Buyer Milestone Tracker ──────────────────────────────────────────────
  buyerTracker: {
    title: "生产进度",
    inProgress: "进行中",
    pending: "待处理",
    milestones: {
      orderConfirmed: "订单确认",
      designEngineering: "设计工程",
      sampleProduction: "样品生产",
      approval: "审批确认",
      manufacturing: "量产制造",
      finalFinishing: "最终修饰",
      qualityCheckDelivery: "质量检测及交付",
    },
  },
};
